// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { addBatchFiles, addMembers, adjustUserGroupMemberSkill, archiveAssetMetadataKey, archiveEvaluationProfile, archiveOutputName, assignPlatformAdminRole, assignRolesToUsers, assignSpecificTaskToUser, assignTaskToUser, assignUserToGroup, attachAiNodeAsset, bulkCancelWorkItems, bulkReopenWorkItems, bulkUnassignTasks, bulkUnassignUsersFromGroup, completeUserTask, countAssets, countDatasets, countMembers, countPlatformProjects, countTasks, countUserGroupMembers, countWorkItems, createAiAsset, createAiNode, createAiNodeVersion, createApiKey, createAsset, createAssetMetadataKey, createAttributes, createAttributeVersion, createBatch, createBucketMountDiscovery, createCompany, createDataset, createEvalExpression, createEvaluationProfile, createEvaluationProfileVersion, createForm, createFormVersion, createGuideline, createGuidelineAsset, createGuidelineVersion, createJob, createLabelClasses, createLabelClassVersion, createOutputName, createOutputNameLink, createProject, createQcSamplingPolicy, createServiceAccountV2, createSowConfig, createSpace, createSplit, createTaxonomy, createTaxonomyVersion, createUserGroup, createWebhook, createWorkflow, createWorkItemMetadataForm, deleteAiNodeTag, deleteAsset, deleteAssetImport, deleteCompany, deleteDataset, deleteForm, deleteGuideline, deleteProject, deleteServiceAccount, deleteSpace, deleteTaxonomy, deleteWebhook, deprecateAiNode, detachAiNodeAsset, forceCompleteTask, getAiAssetById, getAiNode, getAnalyticsDashboardUrl, getAnnotationConfig, getApiKey, getAssetById, getAssetImport, getAssetMetadataValues, getAttribute, getAttributeVersion, getBatchById, getBatchCount, getBatchPrioritization, getBucketMount, getBucketMountDiscovery, getBulkForceCompleteJob, getClassLayout, getCompanyById, getEvalExpression, getEvaluationProfile, getEvaluationProfileVersion, getForm, getFormDetailsFromAnnotation, getFormVersion, getGuideline, getGuidelineUploadUrls, getGuidelineVersion, getLabelClass, getLabelClassVersion, getMember, getOutputName, getProjectById, getProjectCollaborators, getProjectPriorityConfig, getProjectSetting, getProjectWorkflowSetting, getQcSamplingPolicy, getServiceAccount, getSignedUrls, getSowConfig, getSowConfigSlaAlertConfig, getSpaceById, getSpaceSetting, getSplit, getSystemTaxonomy, getTaskById, getTaskDraft, getTaskView, getTaxonomy, getTaxonomyVersion, getUploadUrls, getUserGroupMember, getUserGroupMemberLevelHistory, getWorkflow, getWorkflowDefinitionByVersion, getWorkflowTemplate, getWorkItem, getWorkItemAnnotation, getWorkItemExecution, getWorkItemInference, getWorkItemMetadataForm, getWorkItemsByQuery, healthCheck, importGuideline, internalCancelWorkItem, internalCreateExport, internalDeleteExport, internalDeleteWorkItem, internalGetExport, internalListExports, internalReopenWorkItem, jwtUserLogin, launchGuidelineGeneration, listAiAssets, listAiNodes, listAiNodeTags, listAllWorkflowVersions, listAnnotationsByQuery, listApiKeys, listAssetImports, listAssetMetadataKeys, listAssets, listAssignableTasksForUser, listAttributes, listAttributeVersions, listBatches, listBlockCatalog, listBucketMountDiscoveries, listBucketMountDiscoveryObjects, listCompanies, listDatasets, listEvalExpressions, listEvaluationProfiles, listEvaluationProfileVersions, listForms, listFormVersions, listGuidelineAssetDocuments, listGuidelines, listGuidelineVersions, listJobs, listLabelClasses, listLabelClassVersions, listMembers, listOutputNames, listPermissions, listPlatformAdmins, listPlatformProjects, listProjects, listServiceAccounts, listSpaces, listSplits, listSystemTaxonomies, listTasks, listTaxonomies, listTaxonomyVersions, listUserGroupMembers, listUserGroups, listUserRoles, listWebhooks, listWorkflows, listWorkflowTemplates, listWorkflowVersions, listWorkItems, listWorkItemsStats, loginUser, logoutUser, moveAsset, type Options, patchAiAsset, patchAiNode, processConsensusSampler, processRandomSampler, projectWorkflowSwitch, publishAiNode, publishWorkflow, purgeAsset, reactivateUserInGroup, recordTaskValidationAck, redirectInvite, regenerateApiKey, removeMembers, requestMagicLink, respondToInterruptionOffer, restoreAsset, revokeApiKey, revokePlatformAdminRole, rotateServiceAccountApiKey, saveTaskDraft, setAiNodeTag, setAttributeVersionCurrent, setFormVersionCurrent, setGuidelineVersionCurrent, setLabelClassVersionCurrent, setTaxonomyVersionCurrent, startAssetImport, statusUpdateTasks, submitBulkForceCompleteJob, takeoverTask, testEvalExpression, triggerAssetVpg, unassignTasks, updateAnnotation, updateAttribute, updateBatch, updateCompany, updateEvalExpression, updateEvaluationProfile, updateForm, updateFormVersion, updateGuideline, updateGuidelineVersion, updateLabelClass, updateOutputName, updateProject, updateQcSamplingPolicy, updateRolesFromUsers, updateSowConfig, updateSpace, updateTaxonomy, updateTaxonomyVersion, updateUserGroup, updateUserGroupMember, updateWebhook, updateWorkflow, updateWorkflowDefinition, upsertBatchActivation, upsertBatchPrioritization, upsertBucketMount, upsertClassLayout, upsertProjectPriorityConfig, upsertProjectSetting, upsertProjectWorkflowSetting, upsertSowConfigSlaAlertConfig, upsertSpaceSetting, validateBucketMount, validateGuidelineAsset, validateMagicLink } from '../sdk.gen';
import type { AddBatchFilesData, AddBatchFilesResponse2, AddMembersData, AddMembersResponse, AdjustUserGroupMemberSkillData, AdjustUserGroupMemberSkillResponse, ArchiveAssetMetadataKeyData, ArchiveAssetMetadataKeyError, ArchiveAssetMetadataKeyResponse, ArchiveEvaluationProfileData, ArchiveEvaluationProfileResponse, ArchiveOutputNameData, ArchiveOutputNameResponse, AssignPlatformAdminRoleData, AssignRolesToUsersData, AssignSpecificTaskToUserData, AssignSpecificTaskToUserResponse, AssignTaskToUserData, AssignTaskToUserResponse, AssignUserToGroupData, AttachAiNodeAssetData, AttachAiNodeAssetResponse, BulkCancelWorkItemsData, BulkCancelWorkItemsResponse, BulkReopenWorkItemsData, BulkReopenWorkItemsResponse, BulkUnassignTasksData, BulkUnassignTasksResponse, BulkUnassignUsersFromGroupData, BulkUnassignUsersFromGroupResponse, CompleteUserTaskData, CompleteUserTaskResponse, CountAssetsData, CountDatasetsData, CountMembersData, CountPlatformProjectsData, CountTasksData, CountUserGroupMembersData, CountWorkItemsData, CreateAiAssetData, CreateAiAssetResponse, CreateAiNodeData, CreateAiNodeResponse, CreateAiNodeVersionData, CreateAiNodeVersionResponse, CreateApiKeyData, CreateApiKeyResponse2, CreateAssetData, CreateAssetMetadataKeyData, CreateAssetMetadataKeyError, CreateAssetMetadataKeyResponse, CreateAssetResponse, CreateAttributesData, CreateAttributeVersionData, CreateAttributeVersionResponse, CreateBatchData, CreateBatchResponse, CreateBucketMountDiscoveryData, CreateBucketMountDiscoveryResponse2, CreateCompanyData, CreateCompanyResponse, CreateDatasetData, CreateDatasetResponse, CreateEvalExpressionData, CreateEvalExpressionError, CreateEvalExpressionResponse, CreateEvaluationProfileData, CreateEvaluationProfileResponse, CreateEvaluationProfileVersionData, CreateEvaluationProfileVersionResponse, CreateFormData, CreateFormResponse, CreateFormVersionData, CreateFormVersionResponse, CreateGuidelineAssetData, CreateGuidelineAssetResponse, CreateGuidelineData, CreateGuidelineResponse, CreateGuidelineVersionData, CreateGuidelineVersionResponse, CreateJobData, CreateJobResponse2, CreateLabelClassesData, CreateLabelClassVersionData, CreateLabelClassVersionResponse, CreateOutputNameData, CreateOutputNameLinkData, CreateOutputNameLinkResponse, CreateOutputNameResponse, CreateProjectData, CreateProjectResponse, CreateQcSamplingPolicyData, CreateQcSamplingPolicyResponse, CreateServiceAccountV2Data, CreateServiceAccountV2Response, CreateSowConfigData, CreateSowConfigResponse, CreateSpaceData, CreateSpaceResponse, CreateSplitData, CreateSplitResponse2, CreateTaxonomyData, CreateTaxonomyResponse, CreateTaxonomyVersionData, CreateTaxonomyVersionResponse, CreateUserGroupData, CreateUserGroupResponse, CreateWebhookData, CreateWebhookResponse, CreateWorkflowData, CreateWorkflowResponse, CreateWorkItemMetadataFormData, CreateWorkItemMetadataFormResponse, DeleteAiNodeTagData, DeleteAiNodeTagResponse, DeleteAssetData, DeleteAssetError, DeleteAssetImportData, DeleteAssetImportResponse, DeleteAssetResponse, DeleteCompanyData, DeleteDatasetData, DeleteDatasetResponse, DeleteFormData, DeleteFormResponse, DeleteGuidelineData, DeleteGuidelineResponse, DeleteProjectData, DeleteServiceAccountData, DeleteServiceAccountResponse, DeleteSpaceData, DeleteTaxonomyData, DeleteTaxonomyResponse, DeleteWebhookData, DeleteWebhookResponse, DeprecateAiNodeData, DeprecateAiNodeResponse, DetachAiNodeAssetData, DetachAiNodeAssetResponse, ForceCompleteTaskData, ForceCompleteTaskResponse, GetAiAssetByIdData, GetAiNodeData, GetAnalyticsDashboardUrlData, GetAnnotationConfigData, GetApiKeyData, GetAssetByIdData, GetAssetImportData, GetAssetMetadataValuesData, GetAttributeData, GetAttributeVersionData, GetBatchByIdData, GetBatchCountData, GetBatchPrioritizationData, GetBucketMountData, GetBucketMountDiscoveryData, GetBulkForceCompleteJobData, GetClassLayoutData, GetCompanyByIdData, GetEvalExpressionData, GetEvaluationProfileData, GetEvaluationProfileVersionData, GetFormData, GetFormDetailsFromAnnotationData, GetFormVersionData, GetGuidelineData, GetGuidelineUploadUrlsData, GetGuidelineVersionData, GetLabelClassData, GetLabelClassVersionData, GetMemberData, GetOutputNameData, GetProjectByIdData, GetProjectCollaboratorsData, GetProjectPriorityConfigData, GetProjectSettingData, GetProjectWorkflowSettingData, GetQcSamplingPolicyData, GetServiceAccountData, GetSignedUrlsData, GetSignedUrlsResponse, GetSowConfigData, GetSowConfigSlaAlertConfigData, GetSpaceByIdData, GetSpaceSettingData, GetSplitData, GetSystemTaxonomyData, GetTaskByIdData, GetTaskDraftData, GetTaskViewData, GetTaxonomyData, GetTaxonomyVersionData, GetUploadUrlsData, GetUserGroupMemberData, GetUserGroupMemberLevelHistoryData, GetUserGroupMemberLevelHistoryResponse, GetWorkflowData, GetWorkflowDefinitionByVersionData, GetWorkflowTemplateData, GetWorkItemAnnotationData, GetWorkItemData, GetWorkItemExecutionData, GetWorkItemInferenceData, GetWorkItemMetadataFormData, GetWorkItemsByQueryData, GetWorkItemsByQueryResponse, HealthCheckData, ImportGuidelineData, ImportGuidelineResponse2, InternalCancelWorkItemData, InternalCancelWorkItemResponse, InternalCreateExportData, InternalCreateExportResponse, InternalDeleteExportData, InternalDeleteExportResponse, InternalDeleteWorkItemData, InternalDeleteWorkItemResponse, InternalGetExportData, InternalListExportsData, InternalListExportsResponse, InternalReopenWorkItemData, InternalReopenWorkItemResponse, JwtUserLoginData, JwtUserLoginResponse, LaunchGuidelineGenerationData, LaunchGuidelineGenerationResponse, ListAiAssetsData, ListAiAssetsResponse, ListAiNodesData, ListAiNodesResponse, ListAiNodeTagsData, ListAllWorkflowVersionsData, ListAnnotationsByQueryData, ListAnnotationsByQueryResponse, ListApiKeysData, ListAssetImportsData, ListAssetImportsResponse, ListAssetMetadataKeysData, ListAssetsData, ListAssetsResponse, ListAssignableTasksForUserData, ListAttributesData, ListAttributesResponse, ListAttributeVersionsData, ListAttributeVersionsResponse, ListBatchesData, ListBatchesResponse2, ListBlockCatalogData, ListBucketMountDiscoveriesData, ListBucketMountDiscoveriesResponse2, ListBucketMountDiscoveryObjectsData, ListBucketMountDiscoveryObjectsResponse2, ListCompaniesData, ListDatasetsData, ListDatasetsResponse, ListEvalExpressionsData, ListEvaluationProfilesData, ListEvaluationProfileVersionsData, ListEvaluationProfileVersionsResponse2, ListFormsData, ListFormsResponse, ListFormVersionsData, ListFormVersionsResponse, ListGuidelineAssetDocumentsData, ListGuidelinesData, ListGuidelineVersionsData, ListJobsData, ListJobsResponse2, ListLabelClassesData, ListLabelClassesResponse, ListLabelClassVersionsData, ListLabelClassVersionsResponse, ListMembersData, ListMembersResponse, ListOutputNamesData, ListPermissionsData, ListPlatformAdminsData, ListPlatformProjectsData, ListPlatformProjectsResponse, ListProjectsData, ListProjectsResponse, ListServiceAccountsData, ListSpacesData, ListSplitsData, ListSplitsResponse2, ListSystemTaxonomiesData, ListSystemTaxonomiesResponse, ListTasksData, ListTasksResponse, ListTaxonomiesData, ListTaxonomiesResponse, ListTaxonomyVersionsData, ListTaxonomyVersionsResponse, ListUserGroupMembersData, ListUserGroupMembersResponse, ListUserGroupsData, ListUserRolesData, ListWebhooksData, ListWorkflowsData, ListWorkflowTemplatesData, ListWorkflowTemplatesResponse, ListWorkflowVersionsData, ListWorkItemsData, ListWorkItemsResponse, ListWorkItemsStatsData, LoginUserData, LoginUserResponse, LogoutUserData, LogoutUserResponse, MoveAssetData, MoveAssetError, MoveAssetResponse, PatchAiAssetData, PatchAiAssetResponse, PatchAiNodeData, PatchAiNodeResponse, ProcessConsensusSamplerData, ProcessConsensusSamplerResponse, ProcessRandomSamplerData, ProcessRandomSamplerResponse, ProjectWorkflowSwitchData, ProjectWorkflowSwitchError, ProjectWorkflowSwitchResponse, PublishAiNodeData, PublishAiNodeResponse, PublishWorkflowData, PublishWorkflowError, PublishWorkflowResponse, PurgeAssetData, PurgeAssetError, PurgeAssetResponse, ReactivateUserInGroupData, RecordTaskValidationAckData, RecordTaskValidationAckResponse, RedirectInviteData, RegenerateApiKeyData, RegenerateApiKeyResponse, RemoveMembersData, RemoveMembersResponse, RequestMagicLinkData, RequestMagicLinkResponse, RespondToInterruptionOfferData, RespondToInterruptionOfferResponse, RestoreAssetData, RestoreAssetError, RestoreAssetResponse, RevokeApiKeyData, RevokeApiKeyResponse, RevokePlatformAdminRoleData, RotateServiceAccountApiKeyData, RotateServiceAccountApiKeyResponse, SaveTaskDraftData, SaveTaskDraftResponse, SetAiNodeTagData, SetAiNodeTagResponse, SetAttributeVersionCurrentData, SetFormVersionCurrentData, SetFormVersionCurrentResponse, SetGuidelineVersionCurrentData, SetGuidelineVersionCurrentResponse, SetLabelClassVersionCurrentData, SetTaxonomyVersionCurrentData, SetTaxonomyVersionCurrentResponse, StartAssetImportData, StartAssetImportResponse, StatusUpdateTasksData, StatusUpdateTasksResponse, SubmitBulkForceCompleteJobData, SubmitBulkForceCompleteJobResponse, TakeoverTaskData, TakeoverTaskResponse, TestEvalExpressionData, TestEvalExpressionError, TestEvalExpressionResponse2, TriggerAssetVpgData, TriggerAssetVpgError, UnassignTasksData, UpdateAnnotationData, UpdateAnnotationResponse, UpdateAttributeData, UpdateAttributeResponse, UpdateBatchData, UpdateBatchResponse, UpdateCompanyData, UpdateCompanyResponse, UpdateEvalExpressionData, UpdateEvalExpressionError, UpdateEvalExpressionResponse, UpdateEvaluationProfileData, UpdateEvaluationProfileResponse, UpdateFormData, UpdateFormResponse, UpdateFormVersionData, UpdateFormVersionResponse, UpdateGuidelineData, UpdateGuidelineResponse, UpdateGuidelineVersionData, UpdateGuidelineVersionResponse, UpdateLabelClassData, UpdateLabelClassResponse, UpdateOutputNameData, UpdateOutputNameResponse, UpdateProjectData, UpdateProjectResponse, UpdateQcSamplingPolicyData, UpdateQcSamplingPolicyResponse, UpdateRolesFromUsersData, UpdateSowConfigData, UpdateSowConfigResponse, UpdateSpaceData, UpdateSpaceResponse, UpdateTaxonomyData, UpdateTaxonomyResponse, UpdateTaxonomyVersionData, UpdateTaxonomyVersionResponse, UpdateUserGroupData, UpdateUserGroupMemberData, UpdateUserGroupMemberResponse2, UpdateUserGroupResponse, UpdateWebhookData, UpdateWebhookResponse, UpdateWorkflowData, UpdateWorkflowDefinitionData, UpdateWorkflowDefinitionError, UpdateWorkflowDefinitionResponse2, UpdateWorkflowResponse, UpsertBatchActivationData, UpsertBatchActivationResponse, UpsertBatchPrioritizationData, UpsertBatchPrioritizationResponse, UpsertBucketMountData, UpsertBucketMountResponse, UpsertClassLayoutData, UpsertClassLayoutResponse, UpsertProjectPriorityConfigData, UpsertProjectPriorityConfigError, UpsertProjectPriorityConfigResponse, UpsertProjectSettingData, UpsertProjectSettingResponse, UpsertProjectWorkflowSettingData, UpsertProjectWorkflowSettingResponse, UpsertSowConfigSlaAlertConfigData, UpsertSowConfigSlaAlertConfigResponse, UpsertSpaceSettingData, UpsertSpaceSettingResponse, ValidateBucketMountData, ValidateBucketMountError, ValidateBucketMountResponse, ValidateGuidelineAssetData, ValidateGuidelineAssetResponse, ValidateMagicLinkData, ValidateMagicLinkResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [
        params
    ];
};

export const healthCheckQueryKey = (options?: Options<HealthCheckData>) => createQueryKey('healthCheck', options);

/**
 * Health check endpoint
 */
export const healthCheckOptions = (options?: Options<HealthCheckData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await healthCheck({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: healthCheckQueryKey(options)
    });
};

export const listAiAssetsQueryKey = (options: Options<ListAiAssetsData>) => createQueryKey('listAiAssets', options);

/**
 * List and search AI assets
 *
 * Returns a list of assets. Soft-deleted assets are excluded. Space-scoped assets are returned ahead of global ones sharing a name.
 */
export const listAiAssetsOptions = (options: Options<ListAiAssetsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listAiAssets({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listAiAssetsQueryKey(options)
    });
};

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = {
        ...queryKey[0]
    };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const listAiAssetsInfiniteQueryKey = (options: Options<ListAiAssetsData>): QueryKey<Options<ListAiAssetsData>> => createQueryKey('listAiAssets', options, true);

/**
 * List and search AI assets
 *
 * Returns a list of assets. Soft-deleted assets are excluded. Space-scoped assets are returned ahead of global ones sharing a name.
 */
export const listAiAssetsInfiniteOptions = (options: Options<ListAiAssetsData>) => {
    return infiniteQueryOptions<ListAiAssetsResponse, DefaultError, InfiniteData<ListAiAssetsResponse>, QueryKey<Options<ListAiAssetsData>>, string | Pick<QueryKey<Options<ListAiAssetsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListAiAssetsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listAiAssets({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listAiAssetsInfiniteQueryKey(options)
    });
};

export const createAiAssetQueryKey = (options: Options<CreateAiAssetData>) => createQueryKey('createAiAsset', options);

/**
 * Register a new AI asset in a space
 *
 * Registers a new asset scoped to a specific space. Enforces URI validation and type checks.
 */
export const createAiAssetOptions = (options: Options<CreateAiAssetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createAiAsset({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createAiAssetQueryKey(options)
    });
};

/**
 * Register a new AI asset in a space
 *
 * Registers a new asset scoped to a specific space. Enforces URI validation and type checks.
 */
export const createAiAssetMutation = (options?: Partial<Options<CreateAiAssetData>>): UseMutationOptions<CreateAiAssetResponse, DefaultError, Options<CreateAiAssetData>> => {
    const mutationOptions: UseMutationOptions<CreateAiAssetResponse, DefaultError, Options<CreateAiAssetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createAiAsset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAiAssetByIdQueryKey = (options: Options<GetAiAssetByIdData>) => createQueryKey('getAiAssetById', options);

/**
 * Get a specific AI asset
 *
 * Retrieves a specific asset by ID. Soft-deleted assets return 404.
 */
export const getAiAssetByIdOptions = (options: Options<GetAiAssetByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAiAssetById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAiAssetByIdQueryKey(options)
    });
};

/**
 * Update an AI asset (Description only)
 *
 * Updates the description of an existing asset. Attempts to modify other fields will be rejected.
 */
export const patchAiAssetMutation = (options?: Partial<Options<PatchAiAssetData>>): UseMutationOptions<PatchAiAssetResponse, DefaultError, Options<PatchAiAssetData>> => {
    const mutationOptions: UseMutationOptions<PatchAiAssetResponse, DefaultError, Options<PatchAiAssetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchAiAsset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listAiNodesQueryKey = (options: Options<ListAiNodesData>) => createQueryKey('listAiNodes', options);

/**
 * List AI nodes
 */
export const listAiNodesOptions = (options: Options<ListAiNodesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listAiNodes({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listAiNodesQueryKey(options)
    });
};

export const listAiNodesInfiniteQueryKey = (options: Options<ListAiNodesData>): QueryKey<Options<ListAiNodesData>> => createQueryKey('listAiNodes', options, true);

/**
 * List AI nodes
 */
export const listAiNodesInfiniteOptions = (options: Options<ListAiNodesData>) => {
    return infiniteQueryOptions<ListAiNodesResponse, DefaultError, InfiniteData<ListAiNodesResponse>, QueryKey<Options<ListAiNodesData>>, string | Pick<QueryKey<Options<ListAiNodesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListAiNodesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listAiNodes({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listAiNodesInfiniteQueryKey(options)
    });
};

export const createAiNodeQueryKey = (options: Options<CreateAiNodeData>) => createQueryKey('createAiNode', options);

/**
 * Create an AI node draft
 */
export const createAiNodeOptions = (options: Options<CreateAiNodeData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createAiNode({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createAiNodeQueryKey(options)
    });
};

/**
 * Create an AI node draft
 */
export const createAiNodeMutation = (options?: Partial<Options<CreateAiNodeData>>): UseMutationOptions<CreateAiNodeResponse, DefaultError, Options<CreateAiNodeData>> => {
    const mutationOptions: UseMutationOptions<CreateAiNodeResponse, DefaultError, Options<CreateAiNodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createAiNode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAiNodeQueryKey = (options: Options<GetAiNodeData>) => createQueryKey('getAiNode', options);

/**
 * Get an AI node
 */
export const getAiNodeOptions = (options: Options<GetAiNodeData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAiNode({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAiNodeQueryKey(options)
    });
};

/**
 * Update an AI node draft
 */
export const patchAiNodeMutation = (options?: Partial<Options<PatchAiNodeData>>): UseMutationOptions<PatchAiNodeResponse, DefaultError, Options<PatchAiNodeData>> => {
    const mutationOptions: UseMutationOptions<PatchAiNodeResponse, DefaultError, Options<PatchAiNodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchAiNode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const publishAiNodeQueryKey = (options: Options<PublishAiNodeData>) => createQueryKey('publishAiNode', options);

/**
 * Publish an AI node draft
 */
export const publishAiNodeOptions = (options: Options<PublishAiNodeData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await publishAiNode({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: publishAiNodeQueryKey(options)
    });
};

/**
 * Publish an AI node draft
 */
export const publishAiNodeMutation = (options?: Partial<Options<PublishAiNodeData>>): UseMutationOptions<PublishAiNodeResponse, DefaultError, Options<PublishAiNodeData>> => {
    const mutationOptions: UseMutationOptions<PublishAiNodeResponse, DefaultError, Options<PublishAiNodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await publishAiNode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createAiNodeVersionQueryKey = (options: Options<CreateAiNodeVersionData>) => createQueryKey('createAiNodeVersion', options);

/**
 * Create a new AI node draft version
 */
export const createAiNodeVersionOptions = (options: Options<CreateAiNodeVersionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createAiNodeVersion({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createAiNodeVersionQueryKey(options)
    });
};

/**
 * Create a new AI node draft version
 */
export const createAiNodeVersionMutation = (options?: Partial<Options<CreateAiNodeVersionData>>): UseMutationOptions<CreateAiNodeVersionResponse, DefaultError, Options<CreateAiNodeVersionData>> => {
    const mutationOptions: UseMutationOptions<CreateAiNodeVersionResponse, DefaultError, Options<CreateAiNodeVersionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createAiNodeVersion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deprecateAiNodeQueryKey = (options: Options<DeprecateAiNodeData>) => createQueryKey('deprecateAiNode', options);

/**
 * Deprecate an AI node
 */
export const deprecateAiNodeOptions = (options: Options<DeprecateAiNodeData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await deprecateAiNode({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: deprecateAiNodeQueryKey(options)
    });
};

/**
 * Deprecate an AI node
 */
export const deprecateAiNodeMutation = (options?: Partial<Options<DeprecateAiNodeData>>): UseMutationOptions<DeprecateAiNodeResponse, DefaultError, Options<DeprecateAiNodeData>> => {
    const mutationOptions: UseMutationOptions<DeprecateAiNodeResponse, DefaultError, Options<DeprecateAiNodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deprecateAiNode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const attachAiNodeAssetQueryKey = (options: Options<AttachAiNodeAssetData>) => createQueryKey('attachAiNodeAsset', options);

/**
 * Attach an asset to an AI node draft
 */
export const attachAiNodeAssetOptions = (options: Options<AttachAiNodeAssetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await attachAiNodeAsset({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: attachAiNodeAssetQueryKey(options)
    });
};

/**
 * Attach an asset to an AI node draft
 */
export const attachAiNodeAssetMutation = (options?: Partial<Options<AttachAiNodeAssetData>>): UseMutationOptions<AttachAiNodeAssetResponse, DefaultError, Options<AttachAiNodeAssetData>> => {
    const mutationOptions: UseMutationOptions<AttachAiNodeAssetResponse, DefaultError, Options<AttachAiNodeAssetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await attachAiNodeAsset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Detach an asset from an AI node draft
 */
export const detachAiNodeAssetMutation = (options?: Partial<Options<DetachAiNodeAssetData>>): UseMutationOptions<DetachAiNodeAssetResponse, DefaultError, Options<DetachAiNodeAssetData>> => {
    const mutationOptions: UseMutationOptions<DetachAiNodeAssetResponse, DefaultError, Options<DetachAiNodeAssetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await detachAiNodeAsset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listAiNodeTagsQueryKey = (options: Options<ListAiNodeTagsData>) => createQueryKey('listAiNodeTags', options);

/**
 * List AI node tags
 */
export const listAiNodeTagsOptions = (options: Options<ListAiNodeTagsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listAiNodeTags({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listAiNodeTagsQueryKey(options)
    });
};

/**
 * Set an AI node tag
 */
export const setAiNodeTagMutation = (options?: Partial<Options<SetAiNodeTagData>>): UseMutationOptions<SetAiNodeTagResponse, DefaultError, Options<SetAiNodeTagData>> => {
    const mutationOptions: UseMutationOptions<SetAiNodeTagResponse, DefaultError, Options<SetAiNodeTagData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setAiNodeTag({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete an AI node tag
 */
export const deleteAiNodeTagMutation = (options?: Partial<Options<DeleteAiNodeTagData>>): UseMutationOptions<DeleteAiNodeTagResponse, DefaultError, Options<DeleteAiNodeTagData>> => {
    const mutationOptions: UseMutationOptions<DeleteAiNodeTagResponse, DefaultError, Options<DeleteAiNodeTagData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteAiNodeTag({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAnalyticsDashboardUrlQueryKey = (options: Options<GetAnalyticsDashboardUrlData>) => createQueryKey('getAnalyticsDashboardUrl', options);

/**
 * Get a scoped Grafana dashboard URL for a project
 *
 * Returns a Grafana dashboard URL pre-signed with a short-lived JWT for the calling user.
 * The JWT embeds company_id, space_id, and project_id so Grafana can filter data
 * at the correct scope (company → space → project hierarchy).
 * Returns 403 if the caller is not a member of the project.
 *
 */
export const getAnalyticsDashboardUrlOptions = (options: Options<GetAnalyticsDashboardUrlData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAnalyticsDashboardUrl({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAnalyticsDashboardUrlQueryKey(options)
    });
};

export const listApiKeysQueryKey = (options?: Options<ListApiKeysData>) => createQueryKey('listApiKeys', options);

/**
 * List API keys for the authenticated user
 */
export const listApiKeysOptions = (options?: Options<ListApiKeysData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listApiKeys({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listApiKeysQueryKey(options)
    });
};

export const createApiKeyQueryKey = (options: Options<CreateApiKeyData>) => createQueryKey('createApiKey', options);

/**
 * Create an API key for the authenticated user
 */
export const createApiKeyOptions = (options: Options<CreateApiKeyData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createApiKey({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createApiKeyQueryKey(options)
    });
};

/**
 * Create an API key for the authenticated user
 */
export const createApiKeyMutation = (options?: Partial<Options<CreateApiKeyData>>): UseMutationOptions<CreateApiKeyResponse2, DefaultError, Options<CreateApiKeyData>> => {
    const mutationOptions: UseMutationOptions<CreateApiKeyResponse2, DefaultError, Options<CreateApiKeyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createApiKey({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke an API key
 */
export const revokeApiKeyMutation = (options?: Partial<Options<RevokeApiKeyData>>): UseMutationOptions<RevokeApiKeyResponse, DefaultError, Options<RevokeApiKeyData>> => {
    const mutationOptions: UseMutationOptions<RevokeApiKeyResponse, DefaultError, Options<RevokeApiKeyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await revokeApiKey({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiKeyQueryKey = (options: Options<GetApiKeyData>) => createQueryKey('getApiKey', options);

/**
 * Get a specific API key for the authenticated user
 */
export const getApiKeyOptions = (options: Options<GetApiKeyData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getApiKey({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getApiKeyQueryKey(options)
    });
};

export const regenerateApiKeyQueryKey = (options: Options<RegenerateApiKeyData>) => createQueryKey('regenerateApiKey', options);

/**
 * Regenerate the API key (revokes old, issues new)
 */
export const regenerateApiKeyOptions = (options: Options<RegenerateApiKeyData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await regenerateApiKey({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: regenerateApiKeyQueryKey(options)
    });
};

/**
 * Regenerate the API key (revokes old, issues new)
 */
export const regenerateApiKeyMutation = (options?: Partial<Options<RegenerateApiKeyData>>): UseMutationOptions<RegenerateApiKeyResponse, DefaultError, Options<RegenerateApiKeyData>> => {
    const mutationOptions: UseMutationOptions<RegenerateApiKeyResponse, DefaultError, Options<RegenerateApiKeyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await regenerateApiKey({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listAssetMetadataKeysQueryKey = (options: Options<ListAssetMetadataKeysData>) => createQueryKey('listAssetMetadataKeys', options);

/**
 * List asset metadata keys for a space
 */
export const listAssetMetadataKeysOptions = (options: Options<ListAssetMetadataKeysData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listAssetMetadataKeys({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listAssetMetadataKeysQueryKey(options)
    });
};

export const createAssetMetadataKeyQueryKey = (options: Options<CreateAssetMetadataKeyData>) => createQueryKey('createAssetMetadataKey', options);

/**
 * Create an asset metadata key
 */
export const createAssetMetadataKeyOptions = (options: Options<CreateAssetMetadataKeyData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createAssetMetadataKey({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createAssetMetadataKeyQueryKey(options)
    });
};

/**
 * Create an asset metadata key
 */
export const createAssetMetadataKeyMutation = (options?: Partial<Options<CreateAssetMetadataKeyData>>): UseMutationOptions<CreateAssetMetadataKeyResponse, CreateAssetMetadataKeyError, Options<CreateAssetMetadataKeyData>> => {
    const mutationOptions: UseMutationOptions<CreateAssetMetadataKeyResponse, CreateAssetMetadataKeyError, Options<CreateAssetMetadataKeyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createAssetMetadataKey({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Archive an asset metadata key
 */
export const archiveAssetMetadataKeyMutation = (options?: Partial<Options<ArchiveAssetMetadataKeyData>>): UseMutationOptions<ArchiveAssetMetadataKeyResponse, ArchiveAssetMetadataKeyError, Options<ArchiveAssetMetadataKeyData>> => {
    const mutationOptions: UseMutationOptions<ArchiveAssetMetadataKeyResponse, ArchiveAssetMetadataKeyError, Options<ArchiveAssetMetadataKeyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await archiveAssetMetadataKey({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAssetMetadataValuesQueryKey = (options: Options<GetAssetMetadataValuesData>) => createQueryKey('getAssetMetadataValues', options);

/**
 * Get all metadata values for an asset
 */
export const getAssetMetadataValuesOptions = (options: Options<GetAssetMetadataValuesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAssetMetadataValues({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAssetMetadataValuesQueryKey(options)
    });
};

/**
 * Delete an asset by ID
 */
export const deleteAssetMutation = (options?: Partial<Options<DeleteAssetData>>): UseMutationOptions<DeleteAssetResponse, DeleteAssetError, Options<DeleteAssetData>> => {
    const mutationOptions: UseMutationOptions<DeleteAssetResponse, DeleteAssetError, Options<DeleteAssetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteAsset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAssetByIdQueryKey = (options: Options<GetAssetByIdData>) => createQueryKey('getAssetById', options);

/**
 * Get an asset by ID
 */
export const getAssetByIdOptions = (options: Options<GetAssetByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAssetById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAssetByIdQueryKey(options)
    });
};

/**
 * Move an asset to a different dataset
 */
export const moveAssetMutation = (options?: Partial<Options<MoveAssetData>>): UseMutationOptions<MoveAssetResponse, MoveAssetError, Options<MoveAssetData>> => {
    const mutationOptions: UseMutationOptions<MoveAssetResponse, MoveAssetError, Options<MoveAssetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await moveAsset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const restoreAssetQueryKey = (options: Options<RestoreAssetData>) => createQueryKey('restoreAsset', options);

/**
 * Restore a soft-deleted asset
 */
export const restoreAssetOptions = (options: Options<RestoreAssetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await restoreAsset({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: restoreAssetQueryKey(options)
    });
};

/**
 * Restore a soft-deleted asset
 */
export const restoreAssetMutation = (options?: Partial<Options<RestoreAssetData>>): UseMutationOptions<RestoreAssetResponse, RestoreAssetError, Options<RestoreAssetData>> => {
    const mutationOptions: UseMutationOptions<RestoreAssetResponse, RestoreAssetError, Options<RestoreAssetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await restoreAsset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const purgeAssetQueryKey = (options: Options<PurgeAssetData>) => createQueryKey('purgeAsset', options);

/**
 * Permanently delete a soft-deleted asset
 */
export const purgeAssetOptions = (options: Options<PurgeAssetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await purgeAsset({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: purgeAssetQueryKey(options)
    });
};

/**
 * Permanently delete a soft-deleted asset
 */
export const purgeAssetMutation = (options?: Partial<Options<PurgeAssetData>>): UseMutationOptions<PurgeAssetResponse, PurgeAssetError, Options<PurgeAssetData>> => {
    const mutationOptions: UseMutationOptions<PurgeAssetResponse, PurgeAssetError, Options<PurgeAssetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await purgeAsset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const countAssetsQueryKey = (options: Options<CountAssetsData>) => createQueryKey('countAssets', options);

/**
 * Count assets in a space
 */
export const countAssetsOptions = (options: Options<CountAssetsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await countAssets({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: countAssetsQueryKey(options)
    });
};

export const listAssetsQueryKey = (options: Options<ListAssetsData>) => createQueryKey('listAssets', options);

/**
 * List assets in a space
 */
export const listAssetsOptions = (options: Options<ListAssetsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listAssets({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listAssetsQueryKey(options)
    });
};

export const listAssetsInfiniteQueryKey = (options: Options<ListAssetsData>): QueryKey<Options<ListAssetsData>> => createQueryKey('listAssets', options, true);

/**
 * List assets in a space
 */
export const listAssetsInfiniteOptions = (options: Options<ListAssetsData>) => {
    return infiniteQueryOptions<ListAssetsResponse, DefaultError, InfiniteData<ListAssetsResponse>, QueryKey<Options<ListAssetsData>>, string | Pick<QueryKey<Options<ListAssetsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListAssetsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listAssets({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listAssetsInfiniteQueryKey(options)
    });
};

export const createAssetQueryKey = (options: Options<CreateAssetData>) => createQueryKey('createAsset', options);

/**
 * Upload an asset to a space
 */
export const createAssetOptions = (options: Options<CreateAssetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createAsset({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createAssetQueryKey(options)
    });
};

/**
 * Upload an asset to a space
 */
export const createAssetMutation = (options?: Partial<Options<CreateAssetData>>): UseMutationOptions<CreateAssetResponse, DefaultError, Options<CreateAssetData>> => {
    const mutationOptions: UseMutationOptions<CreateAssetResponse, DefaultError, Options<CreateAssetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createAsset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUploadUrlsQueryKey = (options: Options<GetUploadUrlsData>) => createQueryKey('getUploadUrls', options);

/**
 * Get signed urls for upload
 */
export const getUploadUrlsOptions = (options: Options<GetUploadUrlsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getUploadUrls({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getUploadUrlsQueryKey(options)
    });
};

export const getSignedUrlsQueryKey = (options: Options<GetSignedUrlsData>) => createQueryKey('getSignedUrls', options);

/**
 * Get signed urls for download
 */
export const getSignedUrlsOptions = (options: Options<GetSignedUrlsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSignedUrls({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getSignedUrlsQueryKey(options)
    });
};

/**
 * Get signed urls for download
 */
export const getSignedUrlsMutation = (options?: Partial<Options<GetSignedUrlsData>>): UseMutationOptions<GetSignedUrlsResponse, DefaultError, Options<GetSignedUrlsData>> => {
    const mutationOptions: UseMutationOptions<GetSignedUrlsResponse, DefaultError, Options<GetSignedUrlsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await getSignedUrls({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listAssetImportsQueryKey = (options: Options<ListAssetImportsData>) => createQueryKey('listAssetImports', options);

/**
 * List asset import jobs for a space
 */
export const listAssetImportsOptions = (options: Options<ListAssetImportsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listAssetImports({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listAssetImportsQueryKey(options)
    });
};

export const listAssetImportsInfiniteQueryKey = (options: Options<ListAssetImportsData>): QueryKey<Options<ListAssetImportsData>> => createQueryKey('listAssetImports', options, true);

/**
 * List asset import jobs for a space
 */
export const listAssetImportsInfiniteOptions = (options: Options<ListAssetImportsData>) => {
    return infiniteQueryOptions<ListAssetImportsResponse, DefaultError, InfiniteData<ListAssetImportsResponse>, QueryKey<Options<ListAssetImportsData>>, string | Pick<QueryKey<Options<ListAssetImportsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListAssetImportsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listAssetImports({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listAssetImportsInfiniteQueryKey(options)
    });
};

export const startAssetImportQueryKey = (options: Options<StartAssetImportData>) => createQueryKey('startAssetImport', options);

/**
 * Start a bulk CSV/XLSX or span labelling JSON asset import
 */
export const startAssetImportOptions = (options: Options<StartAssetImportData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await startAssetImport({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: startAssetImportQueryKey(options)
    });
};

/**
 * Start a bulk CSV/XLSX or span labelling JSON asset import
 */
export const startAssetImportMutation = (options?: Partial<Options<StartAssetImportData>>): UseMutationOptions<StartAssetImportResponse, DefaultError, Options<StartAssetImportData>> => {
    const mutationOptions: UseMutationOptions<StartAssetImportResponse, DefaultError, Options<StartAssetImportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await startAssetImport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete an asset import job
 */
export const deleteAssetImportMutation = (options?: Partial<Options<DeleteAssetImportData>>): UseMutationOptions<DeleteAssetImportResponse, DefaultError, Options<DeleteAssetImportData>> => {
    const mutationOptions: UseMutationOptions<DeleteAssetImportResponse, DefaultError, Options<DeleteAssetImportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteAssetImport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAssetImportQueryKey = (options: Options<GetAssetImportData>) => createQueryKey('getAssetImport', options);

/**
 * Get the status and result of an asset import job
 */
export const getAssetImportOptions = (options: Options<GetAssetImportData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAssetImport({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAssetImportQueryKey(options)
    });
};

export const triggerAssetVpgQueryKey = (options: Options<TriggerAssetVpgData>) => createQueryKey('triggerAssetVpg', options);

/**
 * Trigger VPG job for an asset
 */
export const triggerAssetVpgOptions = (options: Options<TriggerAssetVpgData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await triggerAssetVpg({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: triggerAssetVpgQueryKey(options)
    });
};

/**
 * Trigger VPG job for an asset
 */
export const triggerAssetVpgMutation = (options?: Partial<Options<TriggerAssetVpgData>>): UseMutationOptions<unknown, TriggerAssetVpgError, Options<TriggerAssetVpgData>> => {
    const mutationOptions: UseMutationOptions<unknown, TriggerAssetVpgError, Options<TriggerAssetVpgData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await triggerAssetVpg({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listAttributesQueryKey = (options: Options<ListAttributesData>) => createQueryKey('listAttributes', options);

/**
 * List all attributes in a space (metadata + current version)
 */
export const listAttributesOptions = (options: Options<ListAttributesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listAttributes({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listAttributesQueryKey(options)
    });
};

export const listAttributesInfiniteQueryKey = (options: Options<ListAttributesData>): QueryKey<Options<ListAttributesData>> => createQueryKey('listAttributes', options, true);

/**
 * List all attributes in a space (metadata + current version)
 */
export const listAttributesInfiniteOptions = (options: Options<ListAttributesData>) => {
    return infiniteQueryOptions<ListAttributesResponse, DefaultError, InfiniteData<ListAttributesResponse>, QueryKey<Options<ListAttributesData>>, string | Pick<QueryKey<Options<ListAttributesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListAttributesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listAttributes({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listAttributesInfiniteQueryKey(options)
    });
};

export const createAttributesQueryKey = (options: Options<CreateAttributesData>) => createQueryKey('createAttributes', options);

/**
 * Create attributes and promote their initial versions
 *
 * Creates version 1 for each attribute and sets it as the current version. The operation is atomic; if any item fails, no attributes are created.
 */
export const createAttributesOptions = (options: Options<CreateAttributesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createAttributes({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createAttributesQueryKey(options)
    });
};

/**
 * Create attributes and promote their initial versions
 *
 * Creates version 1 for each attribute and sets it as the current version. The operation is atomic; if any item fails, no attributes are created.
 */
export const createAttributesMutation = (options?: Partial<Options<CreateAttributesData>>): UseMutationOptions<unknown, DefaultError, Options<CreateAttributesData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<CreateAttributesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createAttributes({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAttributeQueryKey = (options: Options<GetAttributeData>) => createQueryKey('getAttribute', options);

/**
 * Get attribute (including current version)
 */
export const getAttributeOptions = (options: Options<GetAttributeData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAttribute({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAttributeQueryKey(options)
    });
};

/**
 * Update attribute (metadata only)
 */
export const updateAttributeMutation = (options?: Partial<Options<UpdateAttributeData>>): UseMutationOptions<UpdateAttributeResponse, DefaultError, Options<UpdateAttributeData>> => {
    const mutationOptions: UseMutationOptions<UpdateAttributeResponse, DefaultError, Options<UpdateAttributeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateAttribute({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listAttributeVersionsQueryKey = (options: Options<ListAttributeVersionsData>) => createQueryKey('listAttributeVersions', options);

/**
 * List all versions of an attribute (metadata only)
 */
export const listAttributeVersionsOptions = (options: Options<ListAttributeVersionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listAttributeVersions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listAttributeVersionsQueryKey(options)
    });
};

export const listAttributeVersionsInfiniteQueryKey = (options: Options<ListAttributeVersionsData>): QueryKey<Options<ListAttributeVersionsData>> => createQueryKey('listAttributeVersions', options, true);

/**
 * List all versions of an attribute (metadata only)
 */
export const listAttributeVersionsInfiniteOptions = (options: Options<ListAttributeVersionsData>) => {
    return infiniteQueryOptions<ListAttributeVersionsResponse, DefaultError, InfiniteData<ListAttributeVersionsResponse>, QueryKey<Options<ListAttributeVersionsData>>, string | Pick<QueryKey<Options<ListAttributeVersionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListAttributeVersionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listAttributeVersions({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listAttributeVersionsInfiniteQueryKey(options)
    });
};

export const createAttributeVersionQueryKey = (options: Options<CreateAttributeVersionData>) => createQueryKey('createAttributeVersion', options);

/**
 * Create a new version of an existing attribute
 */
export const createAttributeVersionOptions = (options: Options<CreateAttributeVersionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createAttributeVersion({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createAttributeVersionQueryKey(options)
    });
};

/**
 * Create a new version of an existing attribute
 */
export const createAttributeVersionMutation = (options?: Partial<Options<CreateAttributeVersionData>>): UseMutationOptions<CreateAttributeVersionResponse, DefaultError, Options<CreateAttributeVersionData>> => {
    const mutationOptions: UseMutationOptions<CreateAttributeVersionResponse, DefaultError, Options<CreateAttributeVersionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createAttributeVersion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAttributeVersionQueryKey = (options: Options<GetAttributeVersionData>) => createQueryKey('getAttributeVersion', options);

/**
 * Get a specific version of an attribute
 */
export const getAttributeVersionOptions = (options: Options<GetAttributeVersionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAttributeVersion({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAttributeVersionQueryKey(options)
    });
};

export const setAttributeVersionCurrentQueryKey = (options: Options<SetAttributeVersionCurrentData>) => createQueryKey('setAttributeVersionCurrent', options);

/**
 * Promote this attribute version to be the current active version
 */
export const setAttributeVersionCurrentOptions = (options: Options<SetAttributeVersionCurrentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await setAttributeVersionCurrent({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: setAttributeVersionCurrentQueryKey(options)
    });
};

/**
 * Promote this attribute version to be the current active version
 */
export const setAttributeVersionCurrentMutation = (options?: Partial<Options<SetAttributeVersionCurrentData>>): UseMutationOptions<unknown, DefaultError, Options<SetAttributeVersionCurrentData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<SetAttributeVersionCurrentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setAttributeVersionCurrent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listBatchesQueryKey = (options: Options<ListBatchesData>) => createQueryKey('listBatches', options);

/**
 * List batches in a project with summary stats
 */
export const listBatchesOptions = (options: Options<ListBatchesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listBatches({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listBatchesQueryKey(options)
    });
};

export const listBatchesInfiniteQueryKey = (options: Options<ListBatchesData>): QueryKey<Options<ListBatchesData>> => createQueryKey('listBatches', options, true);

/**
 * List batches in a project with summary stats
 */
export const listBatchesInfiniteOptions = (options: Options<ListBatchesData>) => {
    return infiniteQueryOptions<ListBatchesResponse2, DefaultError, InfiniteData<ListBatchesResponse2>, QueryKey<Options<ListBatchesData>>, string | Pick<QueryKey<Options<ListBatchesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListBatchesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listBatches({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listBatchesInfiniteQueryKey(options)
    });
};

export const createBatchQueryKey = (options: Options<CreateBatchData>) => createQueryKey('createBatch', options);

/**
 * Create a new batch in a project
 */
export const createBatchOptions = (options: Options<CreateBatchData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createBatch({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createBatchQueryKey(options)
    });
};

export const createBatchInfiniteQueryKey = (options: Options<CreateBatchData>): QueryKey<Options<CreateBatchData>> => createQueryKey('createBatch', options, true);

/**
 * Create a new batch in a project
 */
export const createBatchInfiniteOptions = (options: Options<CreateBatchData>) => {
    return infiniteQueryOptions<CreateBatchResponse, DefaultError, InfiniteData<CreateBatchResponse>, QueryKey<Options<CreateBatchData>>, string | Pick<QueryKey<Options<CreateBatchData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<CreateBatchData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await createBatch({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createBatchInfiniteQueryKey(options)
    });
};

/**
 * Create a new batch in a project
 */
export const createBatchMutation = (options?: Partial<Options<CreateBatchData>>): UseMutationOptions<CreateBatchResponse, DefaultError, Options<CreateBatchData>> => {
    const mutationOptions: UseMutationOptions<CreateBatchResponse, DefaultError, Options<CreateBatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createBatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getBatchCountQueryKey = (options: Options<GetBatchCountData>) => createQueryKey('getBatchCount', options);

/**
 * Get total number of batches in a project
 */
export const getBatchCountOptions = (options: Options<GetBatchCountData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getBatchCount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getBatchCountQueryKey(options)
    });
};

export const getBatchPrioritizationQueryKey = (options: Options<GetBatchPrioritizationData>) => createQueryKey('getBatchPrioritization', options);

/**
 * Get batch prioritization configuration for a project
 */
export const getBatchPrioritizationOptions = (options: Options<GetBatchPrioritizationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getBatchPrioritization({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getBatchPrioritizationQueryKey(options)
    });
};

/**
 * Upsert batch prioritization configuration for a project
 */
export const upsertBatchPrioritizationMutation = (options?: Partial<Options<UpsertBatchPrioritizationData>>): UseMutationOptions<UpsertBatchPrioritizationResponse, DefaultError, Options<UpsertBatchPrioritizationData>> => {
    const mutationOptions: UseMutationOptions<UpsertBatchPrioritizationResponse, DefaultError, Options<UpsertBatchPrioritizationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await upsertBatchPrioritization({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upsert activation state for batches in a project
 */
export const upsertBatchActivationMutation = (options?: Partial<Options<UpsertBatchActivationData>>): UseMutationOptions<UpsertBatchActivationResponse, DefaultError, Options<UpsertBatchActivationData>> => {
    const mutationOptions: UseMutationOptions<UpsertBatchActivationResponse, DefaultError, Options<UpsertBatchActivationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await upsertBatchActivation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getBatchByIdQueryKey = (options: Options<GetBatchByIdData>) => createQueryKey('getBatchById', options);

/**
 * Get a batch by ID
 */
export const getBatchByIdOptions = (options: Options<GetBatchByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getBatchById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getBatchByIdQueryKey(options)
    });
};

export const addBatchFilesQueryKey = (options: Options<AddBatchFilesData>) => createQueryKey('addBatchFiles', options);

/**
 * Create work items (files) in this batch for provided asset IDs
 *
 * Creates work items for the given asset IDs in the specified batch. When project setting `dedupBatchAssetsByAssetId` is enabled, assets that already have an active work item in this batch (status other than CANCELED or DELETED) are silently skipped. The response includes the IDs of newly created work items in `workItemIds` and the asset IDs that were skipped due to existing active work items in `skippedAssetIds`.
 *
 */
export const addBatchFilesOptions = (options: Options<AddBatchFilesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await addBatchFiles({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: addBatchFilesQueryKey(options)
    });
};

/**
 * Create work items (files) in this batch for provided asset IDs
 *
 * Creates work items for the given asset IDs in the specified batch. When project setting `dedupBatchAssetsByAssetId` is enabled, assets that already have an active work item in this batch (status other than CANCELED or DELETED) are silently skipped. The response includes the IDs of newly created work items in `workItemIds` and the asset IDs that were skipped due to existing active work items in `skippedAssetIds`.
 *
 */
export const addBatchFilesMutation = (options?: Partial<Options<AddBatchFilesData>>): UseMutationOptions<AddBatchFilesResponse2, DefaultError, Options<AddBatchFilesData>> => {
    const mutationOptions: UseMutationOptions<AddBatchFilesResponse2, DefaultError, Options<AddBatchFilesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addBatchFiles({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update a batch
 */
export const updateBatchMutation = (options?: Partial<Options<UpdateBatchData>>): UseMutationOptions<UpdateBatchResponse, DefaultError, Options<UpdateBatchData>> => {
    const mutationOptions: UseMutationOptions<UpdateBatchResponse, DefaultError, Options<UpdateBatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateBatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getBucketMountQueryKey = (options: Options<GetBucketMountData>) => createQueryKey('getBucketMount', options);

/**
 * Get bucket mount configuration for a space
 */
export const getBucketMountOptions = (options: Options<GetBucketMountData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getBucketMount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getBucketMountQueryKey(options)
    });
};

/**
 * Validate and activate bucket mount configuration for a space
 *
 * Allows users to rotate bucket mount credentials.
 * Users are responsible for ensuring updated credentials still point to the intended mount configuration.
 *
 */
export const upsertBucketMountMutation = (options?: Partial<Options<UpsertBucketMountData>>): UseMutationOptions<UpsertBucketMountResponse, DefaultError, Options<UpsertBucketMountData>> => {
    const mutationOptions: UseMutationOptions<UpsertBucketMountResponse, DefaultError, Options<UpsertBucketMountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await upsertBucketMount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const validateBucketMountQueryKey = (options: Options<ValidateBucketMountData>) => createQueryKey('validateBucketMount', options);

/**
 * Validate bucket mount configuration without persisting it
 */
export const validateBucketMountOptions = (options: Options<ValidateBucketMountData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await validateBucketMount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: validateBucketMountQueryKey(options)
    });
};

/**
 * Validate bucket mount configuration without persisting it
 */
export const validateBucketMountMutation = (options?: Partial<Options<ValidateBucketMountData>>): UseMutationOptions<ValidateBucketMountResponse, ValidateBucketMountError, Options<ValidateBucketMountData>> => {
    const mutationOptions: UseMutationOptions<ValidateBucketMountResponse, ValidateBucketMountError, Options<ValidateBucketMountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await validateBucketMount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listBucketMountDiscoveriesQueryKey = (options: Options<ListBucketMountDiscoveriesData>) => createQueryKey('listBucketMountDiscoveries', options);

/**
 * List bucket mount discovery workflows for a space
 *
 * Returns only the latest 50 discovery workflows, sorted by `createdAt` descending.
 * Items older than the most recent 50 are not returned by this endpoint.
 * The `cursor` query parameter is currently ignored for this endpoint and `meta.cursorNext` is always empty.
 *
 */
export const listBucketMountDiscoveriesOptions = (options: Options<ListBucketMountDiscoveriesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listBucketMountDiscoveries({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listBucketMountDiscoveriesQueryKey(options)
    });
};

export const listBucketMountDiscoveriesInfiniteQueryKey = (options: Options<ListBucketMountDiscoveriesData>): QueryKey<Options<ListBucketMountDiscoveriesData>> => createQueryKey('listBucketMountDiscoveries', options, true);

/**
 * List bucket mount discovery workflows for a space
 *
 * Returns only the latest 50 discovery workflows, sorted by `createdAt` descending.
 * Items older than the most recent 50 are not returned by this endpoint.
 * The `cursor` query parameter is currently ignored for this endpoint and `meta.cursorNext` is always empty.
 *
 */
export const listBucketMountDiscoveriesInfiniteOptions = (options: Options<ListBucketMountDiscoveriesData>) => {
    return infiniteQueryOptions<ListBucketMountDiscoveriesResponse2, DefaultError, InfiniteData<ListBucketMountDiscoveriesResponse2>, QueryKey<Options<ListBucketMountDiscoveriesData>>, string | Pick<QueryKey<Options<ListBucketMountDiscoveriesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListBucketMountDiscoveriesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listBucketMountDiscoveries({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listBucketMountDiscoveriesInfiniteQueryKey(options)
    });
};

export const createBucketMountDiscoveryQueryKey = (options: Options<CreateBucketMountDiscoveryData>) => createQueryKey('createBucketMountDiscovery', options);

/**
 * Trigger bucket mount discovery for a space
 */
export const createBucketMountDiscoveryOptions = (options: Options<CreateBucketMountDiscoveryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createBucketMountDiscovery({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createBucketMountDiscoveryQueryKey(options)
    });
};

/**
 * Trigger bucket mount discovery for a space
 */
export const createBucketMountDiscoveryMutation = (options?: Partial<Options<CreateBucketMountDiscoveryData>>): UseMutationOptions<CreateBucketMountDiscoveryResponse2, DefaultError, Options<CreateBucketMountDiscoveryData>> => {
    const mutationOptions: UseMutationOptions<CreateBucketMountDiscoveryResponse2, DefaultError, Options<CreateBucketMountDiscoveryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createBucketMountDiscovery({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getBucketMountDiscoveryQueryKey = (options: Options<GetBucketMountDiscoveryData>) => createQueryKey('getBucketMountDiscovery', options);

/**
 * Get bucket mount discovery workflow details
 */
export const getBucketMountDiscoveryOptions = (options: Options<GetBucketMountDiscoveryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getBucketMountDiscovery({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getBucketMountDiscoveryQueryKey(options)
    });
};

export const listBucketMountDiscoveryObjectsQueryKey = (options: Options<ListBucketMountDiscoveryObjectsData>) => createQueryKey('listBucketMountDiscoveryObjects', options);

/**
 * List object-level bucket mount discovery results
 */
export const listBucketMountDiscoveryObjectsOptions = (options: Options<ListBucketMountDiscoveryObjectsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listBucketMountDiscoveryObjects({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listBucketMountDiscoveryObjectsQueryKey(options)
    });
};

export const listBucketMountDiscoveryObjectsInfiniteQueryKey = (options: Options<ListBucketMountDiscoveryObjectsData>): QueryKey<Options<ListBucketMountDiscoveryObjectsData>> => createQueryKey('listBucketMountDiscoveryObjects', options, true);

/**
 * List object-level bucket mount discovery results
 */
export const listBucketMountDiscoveryObjectsInfiniteOptions = (options: Options<ListBucketMountDiscoveryObjectsData>) => {
    return infiniteQueryOptions<ListBucketMountDiscoveryObjectsResponse2, DefaultError, InfiniteData<ListBucketMountDiscoveryObjectsResponse2>, QueryKey<Options<ListBucketMountDiscoveryObjectsData>>, string | Pick<QueryKey<Options<ListBucketMountDiscoveryObjectsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListBucketMountDiscoveryObjectsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listBucketMountDiscoveryObjects({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listBucketMountDiscoveryObjectsInfiniteQueryKey(options)
    });
};

export const listCompaniesQueryKey = (options?: Options<ListCompaniesData>) => createQueryKey('listCompanies', options);

/**
 * List companies
 */
export const listCompaniesOptions = (options?: Options<ListCompaniesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listCompanies({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listCompaniesQueryKey(options)
    });
};

export const createCompanyQueryKey = (options: Options<CreateCompanyData>) => createQueryKey('createCompany', options);

/**
 * Create a new company
 */
export const createCompanyOptions = (options: Options<CreateCompanyData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createCompany({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createCompanyQueryKey(options)
    });
};

/**
 * Create a new company
 */
export const createCompanyMutation = (options?: Partial<Options<CreateCompanyData>>): UseMutationOptions<CreateCompanyResponse, DefaultError, Options<CreateCompanyData>> => {
    const mutationOptions: UseMutationOptions<CreateCompanyResponse, DefaultError, Options<CreateCompanyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createCompany({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Soft deletes a company
 */
export const deleteCompanyMutation = (options?: Partial<Options<DeleteCompanyData>>): UseMutationOptions<unknown, DefaultError, Options<DeleteCompanyData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeleteCompanyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteCompany({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCompanyByIdQueryKey = (options: Options<GetCompanyByIdData>) => createQueryKey('getCompanyById', options);

/**
 * Get a company by ID
 */
export const getCompanyByIdOptions = (options: Options<GetCompanyByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCompanyById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCompanyByIdQueryKey(options)
    });
};

/**
 * Update a company
 */
export const updateCompanyMutation = (options?: Partial<Options<UpdateCompanyData>>): UseMutationOptions<UpdateCompanyResponse, DefaultError, Options<UpdateCompanyData>> => {
    const mutationOptions: UseMutationOptions<UpdateCompanyResponse, DefaultError, Options<UpdateCompanyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateCompany({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listDatasetsQueryKey = (options: Options<ListDatasetsData>) => createQueryKey('listDatasets', options);

/**
 * List datasets in a space
 */
export const listDatasetsOptions = (options: Options<ListDatasetsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listDatasets({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listDatasetsQueryKey(options)
    });
};

export const listDatasetsInfiniteQueryKey = (options: Options<ListDatasetsData>): QueryKey<Options<ListDatasetsData>> => createQueryKey('listDatasets', options, true);

/**
 * List datasets in a space
 */
export const listDatasetsInfiniteOptions = (options: Options<ListDatasetsData>) => {
    return infiniteQueryOptions<ListDatasetsResponse, DefaultError, InfiniteData<ListDatasetsResponse>, QueryKey<Options<ListDatasetsData>>, string | Pick<QueryKey<Options<ListDatasetsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListDatasetsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listDatasets({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listDatasetsInfiniteQueryKey(options)
    });
};

export const createDatasetQueryKey = (options: Options<CreateDatasetData>) => createQueryKey('createDataset', options);

/**
 * Create a new dataset in a space
 */
export const createDatasetOptions = (options: Options<CreateDatasetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createDataset({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createDatasetQueryKey(options)
    });
};

/**
 * Create a new dataset in a space
 */
export const createDatasetMutation = (options?: Partial<Options<CreateDatasetData>>): UseMutationOptions<CreateDatasetResponse, DefaultError, Options<CreateDatasetData>> => {
    const mutationOptions: UseMutationOptions<CreateDatasetResponse, DefaultError, Options<CreateDatasetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createDataset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a dataset from a space
 */
export const deleteDatasetMutation = (options?: Partial<Options<DeleteDatasetData>>): UseMutationOptions<DeleteDatasetResponse, DefaultError, Options<DeleteDatasetData>> => {
    const mutationOptions: UseMutationOptions<DeleteDatasetResponse, DefaultError, Options<DeleteDatasetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteDataset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const countDatasetsQueryKey = (options: Options<CountDatasetsData>) => createQueryKey('countDatasets', options);

/**
 * Count datasets in a space
 */
export const countDatasetsOptions = (options: Options<CountDatasetsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await countDatasets({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: countDatasetsQueryKey(options)
    });
};

export const listEvaluationProfilesQueryKey = (options: Options<ListEvaluationProfilesData>) => createQueryKey('listEvaluationProfiles', options);

/**
 * List Evaluation Profiles for a project (excludes archived)
 */
export const listEvaluationProfilesOptions = (options: Options<ListEvaluationProfilesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listEvaluationProfiles({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listEvaluationProfilesQueryKey(options)
    });
};

export const createEvaluationProfileQueryKey = (options: Options<CreateEvaluationProfileData>) => createQueryKey('createEvaluationProfile', options);

/**
 * Create a new Evaluation Profile (creates version 1 and makes it current)
 */
export const createEvaluationProfileOptions = (options: Options<CreateEvaluationProfileData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createEvaluationProfile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createEvaluationProfileQueryKey(options)
    });
};

/**
 * Create a new Evaluation Profile (creates version 1 and makes it current)
 */
export const createEvaluationProfileMutation = (options?: Partial<Options<CreateEvaluationProfileData>>): UseMutationOptions<CreateEvaluationProfileResponse, DefaultError, Options<CreateEvaluationProfileData>> => {
    const mutationOptions: UseMutationOptions<CreateEvaluationProfileResponse, DefaultError, Options<CreateEvaluationProfileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createEvaluationProfile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Archive an Evaluation Profile (soft delete; versions and results are preserved)
 */
export const archiveEvaluationProfileMutation = (options?: Partial<Options<ArchiveEvaluationProfileData>>): UseMutationOptions<ArchiveEvaluationProfileResponse, DefaultError, Options<ArchiveEvaluationProfileData>> => {
    const mutationOptions: UseMutationOptions<ArchiveEvaluationProfileResponse, DefaultError, Options<ArchiveEvaluationProfileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await archiveEvaluationProfile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getEvaluationProfileQueryKey = (options: Options<GetEvaluationProfileData>) => createQueryKey('getEvaluationProfile', options);

/**
 * Get an Evaluation Profile (including its current version)
 */
export const getEvaluationProfileOptions = (options: Options<GetEvaluationProfileData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getEvaluationProfile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getEvaluationProfileQueryKey(options)
    });
};

/**
 * Update Evaluation Profile metadata (name and description)
 */
export const updateEvaluationProfileMutation = (options?: Partial<Options<UpdateEvaluationProfileData>>): UseMutationOptions<UpdateEvaluationProfileResponse, DefaultError, Options<UpdateEvaluationProfileData>> => {
    const mutationOptions: UseMutationOptions<UpdateEvaluationProfileResponse, DefaultError, Options<UpdateEvaluationProfileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateEvaluationProfile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listEvaluationProfileVersionsQueryKey = (options: Options<ListEvaluationProfileVersionsData>) => createQueryKey('listEvaluationProfileVersions', options);

/**
 * List all Evaluation Profile Versions for a profile
 */
export const listEvaluationProfileVersionsOptions = (options: Options<ListEvaluationProfileVersionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listEvaluationProfileVersions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listEvaluationProfileVersionsQueryKey(options)
    });
};

export const listEvaluationProfileVersionsInfiniteQueryKey = (options: Options<ListEvaluationProfileVersionsData>): QueryKey<Options<ListEvaluationProfileVersionsData>> => createQueryKey('listEvaluationProfileVersions', options, true);

/**
 * List all Evaluation Profile Versions for a profile
 */
export const listEvaluationProfileVersionsInfiniteOptions = (options: Options<ListEvaluationProfileVersionsData>) => {
    return infiniteQueryOptions<ListEvaluationProfileVersionsResponse2, DefaultError, InfiniteData<ListEvaluationProfileVersionsResponse2>, QueryKey<Options<ListEvaluationProfileVersionsData>>, string | Pick<QueryKey<Options<ListEvaluationProfileVersionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListEvaluationProfileVersionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listEvaluationProfileVersions({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listEvaluationProfileVersionsInfiniteQueryKey(options)
    });
};

export const createEvaluationProfileVersionQueryKey = (options: Options<CreateEvaluationProfileVersionData>) => createQueryKey('createEvaluationProfileVersion', options);

/**
 * Create the next immutable Evaluation Profile Version and make it current
 */
export const createEvaluationProfileVersionOptions = (options: Options<CreateEvaluationProfileVersionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createEvaluationProfileVersion({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createEvaluationProfileVersionQueryKey(options)
    });
};

/**
 * Create the next immutable Evaluation Profile Version and make it current
 */
export const createEvaluationProfileVersionMutation = (options?: Partial<Options<CreateEvaluationProfileVersionData>>): UseMutationOptions<CreateEvaluationProfileVersionResponse, DefaultError, Options<CreateEvaluationProfileVersionData>> => {
    const mutationOptions: UseMutationOptions<CreateEvaluationProfileVersionResponse, DefaultError, Options<CreateEvaluationProfileVersionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createEvaluationProfileVersion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getEvaluationProfileVersionQueryKey = (options: Options<GetEvaluationProfileVersionData>) => createQueryKey('getEvaluationProfileVersion', options);

/**
 * Get a specific Evaluation Profile Version
 */
export const getEvaluationProfileVersionOptions = (options: Options<GetEvaluationProfileVersionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getEvaluationProfileVersion({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getEvaluationProfileVersionQueryKey(options)
    });
};

export const internalListExportsQueryKey = (options: Options<InternalListExportsData>) => createQueryKey('internalListExports', options);

/**
 * List exports for a space
 *
 * Returns all exports for the given space, ordered by creation date (most recent first).
 */
export const internalListExportsOptions = (options: Options<InternalListExportsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await internalListExports({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: internalListExportsQueryKey(options)
    });
};

export const internalListExportsInfiniteQueryKey = (options: Options<InternalListExportsData>): QueryKey<Options<InternalListExportsData>> => createQueryKey('internalListExports', options, true);

/**
 * List exports for a space
 *
 * Returns all exports for the given space, ordered by creation date (most recent first).
 */
export const internalListExportsInfiniteOptions = (options: Options<InternalListExportsData>) => {
    return infiniteQueryOptions<InternalListExportsResponse, DefaultError, InfiniteData<InternalListExportsResponse>, QueryKey<Options<InternalListExportsData>>, string | Pick<QueryKey<Options<InternalListExportsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<InternalListExportsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await internalListExports({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: internalListExportsInfiniteQueryKey(options)
    });
};

export const internalCreateExportQueryKey = (options: Options<InternalCreateExportData>) => createQueryKey('internalCreateExport', options);

/**
 * Create an export
 *
 * Starts an async export as a zip file. Supports COCO_JSON (annotation data, the default), or CSV/JSON with a selectable content: ANNOTATION (default) for annotation output, or ASSET_METADATA for each work item's related asset ID and structured metadata. Only one active export per space is allowed; returns 409 if an export is already running.
 */
export const internalCreateExportOptions = (options: Options<InternalCreateExportData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await internalCreateExport({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: internalCreateExportQueryKey(options)
    });
};

/**
 * Create an export
 *
 * Starts an async export as a zip file. Supports COCO_JSON (annotation data, the default), or CSV/JSON with a selectable content: ANNOTATION (default) for annotation output, or ASSET_METADATA for each work item's related asset ID and structured metadata. Only one active export per space is allowed; returns 409 if an export is already running.
 */
export const internalCreateExportMutation = (options?: Partial<Options<InternalCreateExportData>>): UseMutationOptions<InternalCreateExportResponse, DefaultError, Options<InternalCreateExportData>> => {
    const mutationOptions: UseMutationOptions<InternalCreateExportResponse, DefaultError, Options<InternalCreateExportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await internalCreateExport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete an export
 *
 * Deletes an export and its associated zip file from storage. Can be called for exports in any status.
 */
export const internalDeleteExportMutation = (options?: Partial<Options<InternalDeleteExportData>>): UseMutationOptions<InternalDeleteExportResponse, DefaultError, Options<InternalDeleteExportData>> => {
    const mutationOptions: UseMutationOptions<InternalDeleteExportResponse, DefaultError, Options<InternalDeleteExportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await internalDeleteExport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const internalGetExportQueryKey = (options: Options<InternalGetExportData>) => createQueryKey('internalGetExport', options);

/**
 * Get export status
 *
 * Returns the current status of an export. When COMPLETED, includes a pre-signed download URL valid for 7 days.
 */
export const internalGetExportOptions = (options: Options<InternalGetExportData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await internalGetExport({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: internalGetExportQueryKey(options)
    });
};

export const listFormsQueryKey = (options: Options<ListFormsData>) => createQueryKey('listForms', options);

/**
 * List all forms (metadata only)
 */
export const listFormsOptions = (options: Options<ListFormsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listForms({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listFormsQueryKey(options)
    });
};

export const listFormsInfiniteQueryKey = (options: Options<ListFormsData>): QueryKey<Options<ListFormsData>> => createQueryKey('listForms', options, true);

/**
 * List all forms (metadata only)
 */
export const listFormsInfiniteOptions = (options: Options<ListFormsData>) => {
    return infiniteQueryOptions<ListFormsResponse, DefaultError, InfiniteData<ListFormsResponse>, QueryKey<Options<ListFormsData>>, string | Pick<QueryKey<Options<ListFormsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListFormsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listForms({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listFormsInfiniteQueryKey(options)
    });
};

export const createFormQueryKey = (options: Options<CreateFormData>) => createQueryKey('createForm', options);

/**
 * Create a new form (creates version 1)
 */
export const createFormOptions = (options: Options<CreateFormData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createForm({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createFormQueryKey(options)
    });
};

/**
 * Create a new form (creates version 1)
 */
export const createFormMutation = (options?: Partial<Options<CreateFormData>>): UseMutationOptions<CreateFormResponse, DefaultError, Options<CreateFormData>> => {
    const mutationOptions: UseMutationOptions<CreateFormResponse, DefaultError, Options<CreateFormData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createForm({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a form (including all its versions)
 */
export const deleteFormMutation = (options?: Partial<Options<DeleteFormData>>): UseMutationOptions<DeleteFormResponse, DefaultError, Options<DeleteFormData>> => {
    const mutationOptions: UseMutationOptions<DeleteFormResponse, DefaultError, Options<DeleteFormData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteForm({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getFormQueryKey = (options: Options<GetFormData>) => createQueryKey('getForm', options);

/**
 * Get form (including current version)
 */
export const getFormOptions = (options: Options<GetFormData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getForm({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getFormQueryKey(options)
    });
};

/**
 * Update form (metadata only)
 */
export const updateFormMutation = (options?: Partial<Options<UpdateFormData>>): UseMutationOptions<UpdateFormResponse, DefaultError, Options<UpdateFormData>> => {
    const mutationOptions: UseMutationOptions<UpdateFormResponse, DefaultError, Options<UpdateFormData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateForm({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listFormVersionsQueryKey = (options: Options<ListFormVersionsData>) => createQueryKey('listFormVersions', options);

/**
 * List all form versions (metadata only)
 */
export const listFormVersionsOptions = (options: Options<ListFormVersionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listFormVersions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listFormVersionsQueryKey(options)
    });
};

export const listFormVersionsInfiniteQueryKey = (options: Options<ListFormVersionsData>): QueryKey<Options<ListFormVersionsData>> => createQueryKey('listFormVersions', options, true);

/**
 * List all form versions (metadata only)
 */
export const listFormVersionsInfiniteOptions = (options: Options<ListFormVersionsData>) => {
    return infiniteQueryOptions<ListFormVersionsResponse, DefaultError, InfiniteData<ListFormVersionsResponse>, QueryKey<Options<ListFormVersionsData>>, string | Pick<QueryKey<Options<ListFormVersionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListFormVersionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listFormVersions({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listFormVersionsInfiniteQueryKey(options)
    });
};

export const createFormVersionQueryKey = (options: Options<CreateFormVersionData>) => createQueryKey('createFormVersion', options);

/**
 * Create a new version of an existing form
 */
export const createFormVersionOptions = (options: Options<CreateFormVersionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createFormVersion({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createFormVersionQueryKey(options)
    });
};

/**
 * Create a new version of an existing form
 */
export const createFormVersionMutation = (options?: Partial<Options<CreateFormVersionData>>): UseMutationOptions<CreateFormVersionResponse, DefaultError, Options<CreateFormVersionData>> => {
    const mutationOptions: UseMutationOptions<CreateFormVersionResponse, DefaultError, Options<CreateFormVersionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createFormVersion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getFormVersionQueryKey = (options: Options<GetFormVersionData>) => createQueryKey('getFormVersion', options);

/**
 * Get a specific version of a form
 */
export const getFormVersionOptions = (options: Options<GetFormVersionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFormVersion({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getFormVersionQueryKey(options)
    });
};

/**
 * Update form version (metadata only)
 */
export const updateFormVersionMutation = (options?: Partial<Options<UpdateFormVersionData>>): UseMutationOptions<UpdateFormVersionResponse, DefaultError, Options<UpdateFormVersionData>> => {
    const mutationOptions: UseMutationOptions<UpdateFormVersionResponse, DefaultError, Options<UpdateFormVersionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateFormVersion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const setFormVersionCurrentQueryKey = (options: Options<SetFormVersionCurrentData>) => createQueryKey('setFormVersionCurrent', options);

/**
 * Set this form version as the current version
 */
export const setFormVersionCurrentOptions = (options: Options<SetFormVersionCurrentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await setFormVersionCurrent({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: setFormVersionCurrentQueryKey(options)
    });
};

/**
 * Set this form version as the current version
 */
export const setFormVersionCurrentMutation = (options?: Partial<Options<SetFormVersionCurrentData>>): UseMutationOptions<SetFormVersionCurrentResponse, DefaultError, Options<SetFormVersionCurrentData>> => {
    const mutationOptions: UseMutationOptions<SetFormVersionCurrentResponse, DefaultError, Options<SetFormVersionCurrentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setFormVersionCurrent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listGuidelinesQueryKey = (options: Options<ListGuidelinesData>) => createQueryKey('listGuidelines', options);

/**
 * List all guidelines
 */
export const listGuidelinesOptions = (options: Options<ListGuidelinesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listGuidelines({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listGuidelinesQueryKey(options)
    });
};

export const createGuidelineQueryKey = (options: Options<CreateGuidelineData>) => createQueryKey('createGuideline', options);

/**
 * Create a new Guidelien (creates version 1)
 */
export const createGuidelineOptions = (options: Options<CreateGuidelineData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createGuideline({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createGuidelineQueryKey(options)
    });
};

/**
 * Create a new Guidelien (creates version 1)
 */
export const createGuidelineMutation = (options?: Partial<Options<CreateGuidelineData>>): UseMutationOptions<CreateGuidelineResponse, DefaultError, Options<CreateGuidelineData>> => {
    const mutationOptions: UseMutationOptions<CreateGuidelineResponse, DefaultError, Options<CreateGuidelineData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createGuideline({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a Guideline (including all its versions and asset mappings)
 */
export const deleteGuidelineMutation = (options?: Partial<Options<DeleteGuidelineData>>): UseMutationOptions<DeleteGuidelineResponse, DefaultError, Options<DeleteGuidelineData>> => {
    const mutationOptions: UseMutationOptions<DeleteGuidelineResponse, DefaultError, Options<DeleteGuidelineData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteGuideline({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getGuidelineQueryKey = (options: Options<GetGuidelineData>) => createQueryKey('getGuideline', options);

/**
 * Get Guideline
 */
export const getGuidelineOptions = (options: Options<GetGuidelineData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getGuideline({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getGuidelineQueryKey(options)
    });
};

/**
 * Update guideline metadata
 */
export const updateGuidelineMutation = (options?: Partial<Options<UpdateGuidelineData>>): UseMutationOptions<UpdateGuidelineResponse, DefaultError, Options<UpdateGuidelineData>> => {
    const mutationOptions: UseMutationOptions<UpdateGuidelineResponse, DefaultError, Options<UpdateGuidelineData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateGuideline({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listGuidelineVersionsQueryKey = (options: Options<ListGuidelineVersionsData>) => createQueryKey('listGuidelineVersions', options);

/**
 * List all guideline versions metadata
 */
export const listGuidelineVersionsOptions = (options: Options<ListGuidelineVersionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listGuidelineVersions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listGuidelineVersionsQueryKey(options)
    });
};

export const createGuidelineVersionQueryKey = (options: Options<CreateGuidelineVersionData>) => createQueryKey('createGuidelineVersion', options);

/**
 * Create a new Guideline Version for existing Guideline
 */
export const createGuidelineVersionOptions = (options: Options<CreateGuidelineVersionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createGuidelineVersion({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createGuidelineVersionQueryKey(options)
    });
};

/**
 * Create a new Guideline Version for existing Guideline
 */
export const createGuidelineVersionMutation = (options?: Partial<Options<CreateGuidelineVersionData>>): UseMutationOptions<CreateGuidelineVersionResponse, DefaultError, Options<CreateGuidelineVersionData>> => {
    const mutationOptions: UseMutationOptions<CreateGuidelineVersionResponse, DefaultError, Options<CreateGuidelineVersionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createGuidelineVersion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getGuidelineVersionQueryKey = (options: Options<GetGuidelineVersionData>) => createQueryKey('getGuidelineVersion', options);

/**
 * Get a specific guideline version
 */
export const getGuidelineVersionOptions = (options: Options<GetGuidelineVersionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getGuidelineVersion({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getGuidelineVersionQueryKey(options)
    });
};

/**
 * Update Guideline version metadata only
 */
export const updateGuidelineVersionMutation = (options?: Partial<Options<UpdateGuidelineVersionData>>): UseMutationOptions<UpdateGuidelineVersionResponse, DefaultError, Options<UpdateGuidelineVersionData>> => {
    const mutationOptions: UseMutationOptions<UpdateGuidelineVersionResponse, DefaultError, Options<UpdateGuidelineVersionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateGuidelineVersion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const setGuidelineVersionCurrentQueryKey = (options: Options<SetGuidelineVersionCurrentData>) => createQueryKey('setGuidelineVersionCurrent', options);

/**
 * Set this guideline version as the active version
 */
export const setGuidelineVersionCurrentOptions = (options: Options<SetGuidelineVersionCurrentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await setGuidelineVersionCurrent({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: setGuidelineVersionCurrentQueryKey(options)
    });
};

/**
 * Set this guideline version as the active version
 */
export const setGuidelineVersionCurrentMutation = (options?: Partial<Options<SetGuidelineVersionCurrentData>>): UseMutationOptions<SetGuidelineVersionCurrentResponse, DefaultError, Options<SetGuidelineVersionCurrentData>> => {
    const mutationOptions: UseMutationOptions<SetGuidelineVersionCurrentResponse, DefaultError, Options<SetGuidelineVersionCurrentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setGuidelineVersionCurrent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getGuidelineUploadUrlsQueryKey = (options: Options<GetGuidelineUploadUrlsData>) => createQueryKey('getGuidelineUploadUrls', options);

/**
 * Get signed urls for upload in Guidelines.
 */
export const getGuidelineUploadUrlsOptions = (options: Options<GetGuidelineUploadUrlsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getGuidelineUploadUrls({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getGuidelineUploadUrlsQueryKey(options)
    });
};

export const createGuidelineAssetQueryKey = (options: Options<CreateGuidelineAssetData>) => createQueryKey('createGuidelineAsset', options);

/**
 * Upload Guideline asset.
 */
export const createGuidelineAssetOptions = (options: Options<CreateGuidelineAssetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createGuidelineAsset({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createGuidelineAssetQueryKey(options)
    });
};

/**
 * Upload Guideline asset.
 */
export const createGuidelineAssetMutation = (options?: Partial<Options<CreateGuidelineAssetData>>): UseMutationOptions<CreateGuidelineAssetResponse, DefaultError, Options<CreateGuidelineAssetData>> => {
    const mutationOptions: UseMutationOptions<CreateGuidelineAssetResponse, DefaultError, Options<CreateGuidelineAssetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createGuidelineAsset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listGuidelineAssetDocumentsQueryKey = (options: Options<ListGuidelineAssetDocumentsData>) => createQueryKey('listGuidelineAssetDocuments', options);

/**
 * Get Guideline assets documents.
 */
export const listGuidelineAssetDocumentsOptions = (options: Options<ListGuidelineAssetDocumentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listGuidelineAssetDocuments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listGuidelineAssetDocumentsQueryKey(options)
    });
};

export const validateGuidelineAssetQueryKey = (options: Options<ValidateGuidelineAssetData>) => createQueryKey('validateGuidelineAsset', options);

/**
 * Validate Guideline asset.
 */
export const validateGuidelineAssetOptions = (options: Options<ValidateGuidelineAssetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await validateGuidelineAsset({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: validateGuidelineAssetQueryKey(options)
    });
};

/**
 * Validate Guideline asset.
 */
export const validateGuidelineAssetMutation = (options?: Partial<Options<ValidateGuidelineAssetData>>): UseMutationOptions<ValidateGuidelineAssetResponse, DefaultError, Options<ValidateGuidelineAssetData>> => {
    const mutationOptions: UseMutationOptions<ValidateGuidelineAssetResponse, DefaultError, Options<ValidateGuidelineAssetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await validateGuidelineAsset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const launchGuidelineGenerationQueryKey = (options: Options<LaunchGuidelineGenerationData>) => createQueryKey('launchGuidelineGeneration', options);

/**
 * Launch guideline generation job
 */
export const launchGuidelineGenerationOptions = (options: Options<LaunchGuidelineGenerationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await launchGuidelineGeneration({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: launchGuidelineGenerationQueryKey(options)
    });
};

/**
 * Launch guideline generation job
 */
export const launchGuidelineGenerationMutation = (options?: Partial<Options<LaunchGuidelineGenerationData>>): UseMutationOptions<LaunchGuidelineGenerationResponse, DefaultError, Options<LaunchGuidelineGenerationData>> => {
    const mutationOptions: UseMutationOptions<LaunchGuidelineGenerationResponse, DefaultError, Options<LaunchGuidelineGenerationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await launchGuidelineGeneration({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const loginUserQueryKey = (options?: Options<LoginUserData>) => createQueryKey('loginUser', options);

/**
 * Login or validate session
 */
export const loginUserOptions = (options?: Options<LoginUserData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await loginUser({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: loginUserQueryKey(options)
    });
};

/**
 * Login or validate session
 */
export const loginUserMutation = (options?: Partial<Options<LoginUserData>>): UseMutationOptions<LoginUserResponse, DefaultError, Options<LoginUserData>> => {
    const mutationOptions: UseMutationOptions<LoginUserResponse, DefaultError, Options<LoginUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await loginUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const logoutUserQueryKey = (options?: Options<LogoutUserData>) => createQueryKey('logoutUser', options);

/**
 * Log out the user
 */
export const logoutUserOptions = (options?: Options<LogoutUserData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await logoutUser({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: logoutUserQueryKey(options)
    });
};

/**
 * Log out the user
 */
export const logoutUserMutation = (options?: Partial<Options<LogoutUserData>>): UseMutationOptions<LogoutUserResponse, DefaultError, Options<LogoutUserData>> => {
    const mutationOptions: UseMutationOptions<LogoutUserResponse, DefaultError, Options<LogoutUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await logoutUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const jwtUserLoginQueryKey = (options?: Options<JwtUserLoginData>) => createQueryKey('jwtUserLogin', options);

/**
 * JWT token login
 */
export const jwtUserLoginOptions = (options?: Options<JwtUserLoginData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await jwtUserLogin({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: jwtUserLoginQueryKey(options)
    });
};

/**
 * JWT token login
 */
export const jwtUserLoginMutation = (options?: Partial<Options<JwtUserLoginData>>): UseMutationOptions<JwtUserLoginResponse, DefaultError, Options<JwtUserLoginData>> => {
    const mutationOptions: UseMutationOptions<JwtUserLoginResponse, DefaultError, Options<JwtUserLoginData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await jwtUserLogin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const requestMagicLinkQueryKey = (options: Options<RequestMagicLinkData>) => createQueryKey('requestMagicLink', options);

/**
 * Request a magic link for passwordless login
 *
 * Sends a magic link to the provided email address if the user exists and has active membership.
 * Always returns success to prevent email enumeration attacks.
 *
 */
export const requestMagicLinkOptions = (options: Options<RequestMagicLinkData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await requestMagicLink({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: requestMagicLinkQueryKey(options)
    });
};

/**
 * Request a magic link for passwordless login
 *
 * Sends a magic link to the provided email address if the user exists and has active membership.
 * Always returns success to prevent email enumeration attacks.
 *
 */
export const requestMagicLinkMutation = (options?: Partial<Options<RequestMagicLinkData>>): UseMutationOptions<RequestMagicLinkResponse, DefaultError, Options<RequestMagicLinkData>> => {
    const mutationOptions: UseMutationOptions<RequestMagicLinkResponse, DefaultError, Options<RequestMagicLinkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await requestMagicLink({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const validateMagicLinkQueryKey = (options: Options<ValidateMagicLinkData>) => createQueryKey('validateMagicLink', options);

/**
 * Validate magic link token and create session
 *
 * Validates the magic link JWT token and creates an authenticated session.
 * Returns user info, redirect URL, and sets session cookie on success.
 *
 */
export const validateMagicLinkOptions = (options: Options<ValidateMagicLinkData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await validateMagicLink({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: validateMagicLinkQueryKey(options)
    });
};

/**
 * Validate magic link token and create session
 *
 * Validates the magic link JWT token and creates an authenticated session.
 * Returns user info, redirect URL, and sets session cookie on success.
 *
 */
export const validateMagicLinkMutation = (options?: Partial<Options<ValidateMagicLinkData>>): UseMutationOptions<ValidateMagicLinkResponse, DefaultError, Options<ValidateMagicLinkData>> => {
    const mutationOptions: UseMutationOptions<ValidateMagicLinkResponse, DefaultError, Options<ValidateMagicLinkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await validateMagicLink({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const redirectInviteQueryKey = (options: Options<RedirectInviteData>) => createQueryKey('redirectInvite', options);

/**
 * Get invite redirect URL
 *
 * Validates the invite and returns the redirect path for the frontend.
 * Returns a relative path (e.g., /spaces/xxx/projects/yyy/dashboard).
 * Frontend should use this with router navigation (e.g., router.push(url)).
 *
 */
export const redirectInviteOptions = (options: Options<RedirectInviteData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await redirectInvite({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: redirectInviteQueryKey(options)
    });
};

export const importGuidelineQueryKey = (options: Options<ImportGuidelineData>) => createQueryKey('importGuideline', options);

/**
 * Import a guideline from uploaded PDFs or external source (store without AI generation).
 *
 * Creates a new guideline (or adds a new version if the name already exists)
 * from previously uploaded PDF files (UI) or from an external source (Task Builder/external).
 * The PDFs are stored as-is without triggering AI content generation. The guideline version is immediately published.
 *
 * - For UI: provide `documents` and set `source` to "upload".
 * - For Task Builder/external: provide `document_key` (and optionally `external_ref`), set `source` to "external".
 *
 */
export const importGuidelineOptions = (options: Options<ImportGuidelineData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await importGuideline({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: importGuidelineQueryKey(options)
    });
};

/**
 * Import a guideline from uploaded PDFs or external source (store without AI generation).
 *
 * Creates a new guideline (or adds a new version if the name already exists)
 * from previously uploaded PDF files (UI) or from an external source (Task Builder/external).
 * The PDFs are stored as-is without triggering AI content generation. The guideline version is immediately published.
 *
 * - For UI: provide `documents` and set `source` to "upload".
 * - For Task Builder/external: provide `document_key` (and optionally `external_ref`), set `source` to "external".
 *
 */
export const importGuidelineMutation = (options?: Partial<Options<ImportGuidelineData>>): UseMutationOptions<ImportGuidelineResponse2, DefaultError, Options<ImportGuidelineData>> => {
    const mutationOptions: UseMutationOptions<ImportGuidelineResponse2, DefaultError, Options<ImportGuidelineData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await importGuideline({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listJobsQueryKey = (options?: Options<ListJobsData>) => createQueryKey('listJobs', options);

/**
 * List jobs filtered by labels
 */
export const listJobsOptions = (options?: Options<ListJobsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listJobs({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listJobsQueryKey(options)
    });
};

export const listJobsInfiniteQueryKey = (options?: Options<ListJobsData>): QueryKey<Options<ListJobsData>> => createQueryKey('listJobs', options, true);

/**
 * List jobs filtered by labels
 */
export const listJobsInfiniteOptions = (options?: Options<ListJobsData>) => {
    return infiniteQueryOptions<ListJobsResponse2, DefaultError, InfiniteData<ListJobsResponse2>, QueryKey<Options<ListJobsData>>, string | Pick<QueryKey<Options<ListJobsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListJobsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listJobs({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listJobsInfiniteQueryKey(options)
    });
};

export const createJobQueryKey = (options: Options<CreateJobData>) => createQueryKey('createJob', options);

/**
 * Trigger an Argo workflow job
 */
export const createJobOptions = (options: Options<CreateJobData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createJob({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createJobQueryKey(options)
    });
};

/**
 * Trigger an Argo workflow job
 */
export const createJobMutation = (options?: Partial<Options<CreateJobData>>): UseMutationOptions<CreateJobResponse2, DefaultError, Options<CreateJobData>> => {
    const mutationOptions: UseMutationOptions<CreateJobResponse2, DefaultError, Options<CreateJobData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createJob({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listLabelClassesQueryKey = (options: Options<ListLabelClassesData>) => createQueryKey('listLabelClasses', options);

/**
 * List all label classes in a space (metadata + current version)
 */
export const listLabelClassesOptions = (options: Options<ListLabelClassesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listLabelClasses({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listLabelClassesQueryKey(options)
    });
};

export const listLabelClassesInfiniteQueryKey = (options: Options<ListLabelClassesData>): QueryKey<Options<ListLabelClassesData>> => createQueryKey('listLabelClasses', options, true);

/**
 * List all label classes in a space (metadata + current version)
 */
export const listLabelClassesInfiniteOptions = (options: Options<ListLabelClassesData>) => {
    return infiniteQueryOptions<ListLabelClassesResponse, DefaultError, InfiniteData<ListLabelClassesResponse>, QueryKey<Options<ListLabelClassesData>>, string | Pick<QueryKey<Options<ListLabelClassesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListLabelClassesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listLabelClasses({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listLabelClassesInfiniteQueryKey(options)
    });
};

export const createLabelClassesQueryKey = (options: Options<CreateLabelClassesData>) => createQueryKey('createLabelClasses', options);

/**
 * Create label classes and promote their initial versions
 *
 * Creates version 1 for each label class and sets it as the current version. The operation is atomic; if any item fails, no label classes are created.
 */
export const createLabelClassesOptions = (options: Options<CreateLabelClassesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createLabelClasses({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createLabelClassesQueryKey(options)
    });
};

/**
 * Create label classes and promote their initial versions
 *
 * Creates version 1 for each label class and sets it as the current version. The operation is atomic; if any item fails, no label classes are created.
 */
export const createLabelClassesMutation = (options?: Partial<Options<CreateLabelClassesData>>): UseMutationOptions<unknown, DefaultError, Options<CreateLabelClassesData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<CreateLabelClassesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createLabelClasses({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getLabelClassQueryKey = (options: Options<GetLabelClassData>) => createQueryKey('getLabelClass', options);

/**
 * Get label class (including current version)
 */
export const getLabelClassOptions = (options: Options<GetLabelClassData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getLabelClass({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getLabelClassQueryKey(options)
    });
};

/**
 * Update label class (metadata only)
 */
export const updateLabelClassMutation = (options?: Partial<Options<UpdateLabelClassData>>): UseMutationOptions<UpdateLabelClassResponse, DefaultError, Options<UpdateLabelClassData>> => {
    const mutationOptions: UseMutationOptions<UpdateLabelClassResponse, DefaultError, Options<UpdateLabelClassData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateLabelClass({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listLabelClassVersionsQueryKey = (options: Options<ListLabelClassVersionsData>) => createQueryKey('listLabelClassVersions', options);

/**
 * List all versions of a label class (metadata only)
 */
export const listLabelClassVersionsOptions = (options: Options<ListLabelClassVersionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listLabelClassVersions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listLabelClassVersionsQueryKey(options)
    });
};

export const listLabelClassVersionsInfiniteQueryKey = (options: Options<ListLabelClassVersionsData>): QueryKey<Options<ListLabelClassVersionsData>> => createQueryKey('listLabelClassVersions', options, true);

/**
 * List all versions of a label class (metadata only)
 */
export const listLabelClassVersionsInfiniteOptions = (options: Options<ListLabelClassVersionsData>) => {
    return infiniteQueryOptions<ListLabelClassVersionsResponse, DefaultError, InfiniteData<ListLabelClassVersionsResponse>, QueryKey<Options<ListLabelClassVersionsData>>, string | Pick<QueryKey<Options<ListLabelClassVersionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListLabelClassVersionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listLabelClassVersions({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listLabelClassVersionsInfiniteQueryKey(options)
    });
};

export const createLabelClassVersionQueryKey = (options: Options<CreateLabelClassVersionData>) => createQueryKey('createLabelClassVersion', options);

/**
 * Create a new version of an existing label class
 */
export const createLabelClassVersionOptions = (options: Options<CreateLabelClassVersionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createLabelClassVersion({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createLabelClassVersionQueryKey(options)
    });
};

/**
 * Create a new version of an existing label class
 */
export const createLabelClassVersionMutation = (options?: Partial<Options<CreateLabelClassVersionData>>): UseMutationOptions<CreateLabelClassVersionResponse, DefaultError, Options<CreateLabelClassVersionData>> => {
    const mutationOptions: UseMutationOptions<CreateLabelClassVersionResponse, DefaultError, Options<CreateLabelClassVersionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createLabelClassVersion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getLabelClassVersionQueryKey = (options: Options<GetLabelClassVersionData>) => createQueryKey('getLabelClassVersion', options);

/**
 * Get a specific version of a label class
 */
export const getLabelClassVersionOptions = (options: Options<GetLabelClassVersionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getLabelClassVersion({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getLabelClassVersionQueryKey(options)
    });
};

export const setLabelClassVersionCurrentQueryKey = (options: Options<SetLabelClassVersionCurrentData>) => createQueryKey('setLabelClassVersionCurrent', options);

/**
 * Promote this label class version to be the current active version
 */
export const setLabelClassVersionCurrentOptions = (options: Options<SetLabelClassVersionCurrentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await setLabelClassVersionCurrent({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: setLabelClassVersionCurrentQueryKey(options)
    });
};

/**
 * Promote this label class version to be the current active version
 */
export const setLabelClassVersionCurrentMutation = (options?: Partial<Options<SetLabelClassVersionCurrentData>>): UseMutationOptions<unknown, DefaultError, Options<SetLabelClassVersionCurrentData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<SetLabelClassVersionCurrentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setLabelClassVersionCurrent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getClassLayoutQueryKey = (options: Options<GetClassLayoutData>) => createQueryKey('getClassLayout', options);

/**
 * Get the project's class layout (activation, order, geometry restrictions)
 */
export const getClassLayoutOptions = (options: Options<GetClassLayoutData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getClassLayout({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getClassLayoutQueryKey(options)
    });
};

/**
 * Upsert the project's class layout (bulk-replace; writes an audit snapshot)
 */
export const upsertClassLayoutMutation = (options?: Partial<Options<UpsertClassLayoutData>>): UseMutationOptions<UpsertClassLayoutResponse, DefaultError, Options<UpsertClassLayoutData>> => {
    const mutationOptions: UseMutationOptions<UpsertClassLayoutResponse, DefaultError, Options<UpsertClassLayoutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await upsertClassLayout({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAnnotationConfigQueryKey = (options: Options<GetAnnotationConfigData>) => createQueryKey('getAnnotationConfig', options);

/**
 * Get the active label classes available to the annotation tool
 *
 * Returns only active project class-layout entries, ordered by display order. Each entry resolves the label class's current version, and `referencedSchemas` contains every Attribute Version schema referenced by those versions, so the annotation tool can render attribute forms without additional requests.
 */
export const getAnnotationConfigOptions = (options: Options<GetAnnotationConfigData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAnnotationConfig({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAnnotationConfigQueryKey(options)
    });
};

/**
 * Remove a member from an entity
 */
export const removeMembersMutation = (options?: Partial<Options<RemoveMembersData>>): UseMutationOptions<RemoveMembersResponse, DefaultError, Options<RemoveMembersData>> => {
    const mutationOptions: UseMutationOptions<RemoveMembersResponse, DefaultError, Options<RemoveMembersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeMembers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listMembersQueryKey = (options: Options<ListMembersData>) => createQueryKey('listMembers', options);

/**
 * List all members in a entity
 *
 * Returns the members of an entity. Pagination is opt-in: when none of `limit`, `cursor` or `page` is supplied every matching member is returned and `meta` is omitted.
 */
export const listMembersOptions = (options: Options<ListMembersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listMembers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listMembersQueryKey(options)
    });
};

export const listMembersInfiniteQueryKey = (options: Options<ListMembersData>): QueryKey<Options<ListMembersData>> => createQueryKey('listMembers', options, true);

/**
 * List all members in a entity
 *
 * Returns the members of an entity. Pagination is opt-in: when none of `limit`, `cursor` or `page` is supplied every matching member is returned and `meta` is omitted.
 */
export const listMembersInfiniteOptions = (options: Options<ListMembersData>) => {
    return infiniteQueryOptions<ListMembersResponse, DefaultError, InfiniteData<ListMembersResponse>, QueryKey<Options<ListMembersData>>, string | Pick<QueryKey<Options<ListMembersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListMembersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listMembers({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listMembersInfiniteQueryKey(options)
    });
};

export const addMembersQueryKey = (options: Options<AddMembersData>) => createQueryKey('addMembers', options);

/**
 * Add a member to an entity
 */
export const addMembersOptions = (options: Options<AddMembersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await addMembers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: addMembersQueryKey(options)
    });
};

/**
 * Add a member to an entity
 */
export const addMembersMutation = (options?: Partial<Options<AddMembersData>>): UseMutationOptions<AddMembersResponse, DefaultError, Options<AddMembersData>> => {
    const mutationOptions: UseMutationOptions<AddMembersResponse, DefaultError, Options<AddMembersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addMembers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const countMembersQueryKey = (options: Options<CountMembersData>) => createQueryKey('countMembers', options);

/**
 * Count the members of an entity
 *
 * Returns the number of members of an entity matching the given filters. Accepts the same filters as `listMembers` so that the count reflects the currently displayed result set.
 */
export const countMembersOptions = (options: Options<CountMembersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await countMembers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: countMembersQueryKey(options)
    });
};

export const getMemberQueryKey = (options: Options<GetMemberData>) => createQueryKey('getMember', options);

/**
 * Get details of a specific member
 */
export const getMemberOptions = (options: Options<GetMemberData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMember({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMemberQueryKey(options)
    });
};

export const listOutputNamesQueryKey = (options: Options<ListOutputNamesData>) => createQueryKey('listOutputNames', options);

/**
 * List output names for a given space
 */
export const listOutputNamesOptions = (options: Options<ListOutputNamesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listOutputNames({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listOutputNamesQueryKey(options)
    });
};

export const createOutputNameQueryKey = (options: Options<CreateOutputNameData>) => createQueryKey('createOutputName', options);

/**
 * Create output name for a given space
 */
export const createOutputNameOptions = (options: Options<CreateOutputNameData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createOutputName({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createOutputNameQueryKey(options)
    });
};

/**
 * Create output name for a given space
 */
export const createOutputNameMutation = (options?: Partial<Options<CreateOutputNameData>>): UseMutationOptions<CreateOutputNameResponse, DefaultError, Options<CreateOutputNameData>> => {
    const mutationOptions: UseMutationOptions<CreateOutputNameResponse, DefaultError, Options<CreateOutputNameData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createOutputName({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Archive output name for a given space, and output name ID
 *
 * Archive output name for a given space, and output name ID. The output name will be marked as deleted and will not be returned in future list or get requests.
 */
export const archiveOutputNameMutation = (options?: Partial<Options<ArchiveOutputNameData>>): UseMutationOptions<ArchiveOutputNameResponse, DefaultError, Options<ArchiveOutputNameData>> => {
    const mutationOptions: UseMutationOptions<ArchiveOutputNameResponse, DefaultError, Options<ArchiveOutputNameData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await archiveOutputName({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOutputNameQueryKey = (options: Options<GetOutputNameData>) => createQueryKey('getOutputName', options);

/**
 * Get a specific output name for a given space
 */
export const getOutputNameOptions = (options: Options<GetOutputNameData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOutputName({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOutputNameQueryKey(options)
    });
};

/**
 * Update output name for a given space, and output name ID
 *
 * Update output name for a given space, and output name ID. Only the fields provided in the request body will be updated. Other fields will remain unchanged.
 */
export const updateOutputNameMutation = (options?: Partial<Options<UpdateOutputNameData>>): UseMutationOptions<UpdateOutputNameResponse, DefaultError, Options<UpdateOutputNameData>> => {
    const mutationOptions: UseMutationOptions<UpdateOutputNameResponse, DefaultError, Options<UpdateOutputNameData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateOutputName({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listPermissionsQueryKey = (options?: Options<ListPermissionsData>) => createQueryKey('listPermissions', options);

/**
 * List Role Permissions
 *
 * Returns a map of roles to their associated permissions across all entity types (company, space, project). The permissions are read dynamically from the OpenFGA authorization model.
 */
export const listPermissionsOptions = (options?: Options<ListPermissionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listPermissions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listPermissionsQueryKey(options)
    });
};

export const listPlatformProjectsQueryKey = (options?: Options<ListPlatformProjectsData>) => createQueryKey('listPlatformProjects', options);

/**
 * List platform projects with priority configuration
 *
 * Platform-admin list of all non-deleted projects across organizations,
 * including space/organization names and optional priority-config fields.
 * Default sort is organization name (plus project ID as a tie-breaker).
 * Pass sortBy to order by a different column.
 *
 */
export const listPlatformProjectsOptions = (options?: Options<ListPlatformProjectsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listPlatformProjects({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listPlatformProjectsQueryKey(options)
    });
};

export const listPlatformProjectsInfiniteQueryKey = (options?: Options<ListPlatformProjectsData>): QueryKey<Options<ListPlatformProjectsData>> => createQueryKey('listPlatformProjects', options, true);

/**
 * List platform projects with priority configuration
 *
 * Platform-admin list of all non-deleted projects across organizations,
 * including space/organization names and optional priority-config fields.
 * Default sort is organization name (plus project ID as a tie-breaker).
 * Pass sortBy to order by a different column.
 *
 */
export const listPlatformProjectsInfiniteOptions = (options?: Options<ListPlatformProjectsData>) => {
    return infiniteQueryOptions<ListPlatformProjectsResponse, DefaultError, InfiniteData<ListPlatformProjectsResponse>, QueryKey<Options<ListPlatformProjectsData>>, string | Pick<QueryKey<Options<ListPlatformProjectsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListPlatformProjectsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listPlatformProjects({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listPlatformProjectsInfiniteQueryKey(options)
    });
};

export const countPlatformProjectsQueryKey = (options?: Options<CountPlatformProjectsData>) => createQueryKey('countPlatformProjects', options);

/**
 * Count platform projects matching filters
 *
 * Platform-admin count of non-deleted projects across organizations.
 * Accepts the same companyIDs, spaceIDs, and name filters as listPlatformProjects.
 *
 */
export const countPlatformProjectsOptions = (options?: Options<CountPlatformProjectsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await countPlatformProjects({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: countPlatformProjectsQueryKey(options)
    });
};

export const listProjectsQueryKey = (options: Options<ListProjectsData>) => createQueryKey('listProjects', options);

/**
 * List all projects
 */
export const listProjectsOptions = (options: Options<ListProjectsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listProjects({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listProjectsQueryKey(options)
    });
};

export const listProjectsInfiniteQueryKey = (options: Options<ListProjectsData>): QueryKey<Options<ListProjectsData>> => createQueryKey('listProjects', options, true);

/**
 * List all projects
 */
export const listProjectsInfiniteOptions = (options: Options<ListProjectsData>) => {
    return infiniteQueryOptions<ListProjectsResponse, DefaultError, InfiniteData<ListProjectsResponse>, QueryKey<Options<ListProjectsData>>, string | Pick<QueryKey<Options<ListProjectsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListProjectsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listProjects({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listProjectsInfiniteQueryKey(options)
    });
};

export const createProjectQueryKey = (options: Options<CreateProjectData>) => createQueryKey('createProject', options);

/**
 * Create a new project
 */
export const createProjectOptions = (options: Options<CreateProjectData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createProject({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createProjectQueryKey(options)
    });
};

/**
 * Create a new project
 */
export const createProjectMutation = (options?: Partial<Options<CreateProjectData>>): UseMutationOptions<CreateProjectResponse, DefaultError, Options<CreateProjectData>> => {
    const mutationOptions: UseMutationOptions<CreateProjectResponse, DefaultError, Options<CreateProjectData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createProject({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Soft deletes a project
 */
export const deleteProjectMutation = (options?: Partial<Options<DeleteProjectData>>): UseMutationOptions<unknown, DefaultError, Options<DeleteProjectData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeleteProjectData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteProject({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getProjectByIdQueryKey = (options: Options<GetProjectByIdData>) => createQueryKey('getProjectById', options);

/**
 * Get Project by ID
 */
export const getProjectByIdOptions = (options: Options<GetProjectByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getProjectById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getProjectByIdQueryKey(options)
    });
};

/**
 * Update a project
 */
export const updateProjectMutation = (options?: Partial<Options<UpdateProjectData>>): UseMutationOptions<UpdateProjectResponse, DefaultError, Options<UpdateProjectData>> => {
    const mutationOptions: UseMutationOptions<UpdateProjectResponse, DefaultError, Options<UpdateProjectData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateProject({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Switch workflow for a project
 */
export const projectWorkflowSwitchMutation = (options?: Partial<Options<ProjectWorkflowSwitchData>>): UseMutationOptions<ProjectWorkflowSwitchResponse, ProjectWorkflowSwitchError, Options<ProjectWorkflowSwitchData>> => {
    const mutationOptions: UseMutationOptions<ProjectWorkflowSwitchResponse, ProjectWorkflowSwitchError, Options<ProjectWorkflowSwitchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectWorkflowSwitch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getProjectPriorityConfigQueryKey = (options: Options<GetProjectPriorityConfigData>) => createQueryKey('getProjectPriorityConfig', options);

/**
 * Get priority config for a project
 */
export const getProjectPriorityConfigOptions = (options: Options<GetProjectPriorityConfigData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getProjectPriorityConfig({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getProjectPriorityConfigQueryKey(options)
    });
};

/**
 * Upsert priority config for a project
 */
export const upsertProjectPriorityConfigMutation = (options?: Partial<Options<UpsertProjectPriorityConfigData>>): UseMutationOptions<UpsertProjectPriorityConfigResponse, UpsertProjectPriorityConfigError, Options<UpsertProjectPriorityConfigData>> => {
    const mutationOptions: UseMutationOptions<UpsertProjectPriorityConfigResponse, UpsertProjectPriorityConfigError, Options<UpsertProjectPriorityConfigData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await upsertProjectPriorityConfig({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getProjectCollaboratorsQueryKey = (options: Options<GetProjectCollaboratorsData>) => createQueryKey('getProjectCollaborators', options);

/**
 * Get collaborators for a project
 */
export const getProjectCollaboratorsOptions = (options: Options<GetProjectCollaboratorsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getProjectCollaborators({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getProjectCollaboratorsQueryKey(options)
    });
};

export const listAssignableTasksForUserQueryKey = (options?: Options<ListAssignableTasksForUserData>) => createQueryKey('listAssignableTasksForUser', options);

/**
 * List assignable tasks for the current user
 */
export const listAssignableTasksForUserOptions = (options?: Options<ListAssignableTasksForUserData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listAssignableTasksForUser({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listAssignableTasksForUserQueryKey(options)
    });
};

export const assignSpecificTaskToUserQueryKey = (options: Options<AssignSpecificTaskToUserData>) => createQueryKey('assignSpecificTaskToUser', options);

/**
 * Assign a specific task to the current user
 */
export const assignSpecificTaskToUserOptions = (options: Options<AssignSpecificTaskToUserData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await assignSpecificTaskToUser({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: assignSpecificTaskToUserQueryKey(options)
    });
};

/**
 * Assign a specific task to the current user
 */
export const assignSpecificTaskToUserMutation = (options?: Partial<Options<AssignSpecificTaskToUserData>>): UseMutationOptions<AssignSpecificTaskToUserResponse, DefaultError, Options<AssignSpecificTaskToUserData>> => {
    const mutationOptions: UseMutationOptions<AssignSpecificTaskToUserResponse, DefaultError, Options<AssignSpecificTaskToUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assignSpecificTaskToUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update status from filtered tasks
 */
export const statusUpdateTasksMutation = (options?: Partial<Options<StatusUpdateTasksData>>): UseMutationOptions<StatusUpdateTasksResponse, DefaultError, Options<StatusUpdateTasksData>> => {
    const mutationOptions: UseMutationOptions<StatusUpdateTasksResponse, DefaultError, Options<StatusUpdateTasksData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await statusUpdateTasks({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const respondToInterruptionOfferQueryKey = (options: Options<RespondToInterruptionOfferData>) => createQueryKey('respondToInterruptionOffer', options);

/**
 * Accept or reject a pending interruption offer
 *
 * Lets a CloudWorker respond to an interruption offer created by the priority
 * sweeper (design doc: Dynamic Task Routing — Phase 2, §4.6/§4.10). On accept,
 * in one transaction: releases taskID back to NEW with a resume reservation for
 * this worker, and claims the offered candidate task — returning its
 * FormDetails. If the candidate is no longer claimable, the offer is marked
 * expired and no state on the current session changes. On reject, the current
 * session is left untouched and 204 is returned.
 *
 */
export const respondToInterruptionOfferOptions = (options: Options<RespondToInterruptionOfferData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await respondToInterruptionOffer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: respondToInterruptionOfferQueryKey(options)
    });
};

/**
 * Accept or reject a pending interruption offer
 *
 * Lets a CloudWorker respond to an interruption offer created by the priority
 * sweeper (design doc: Dynamic Task Routing — Phase 2, §4.6/§4.10). On accept,
 * in one transaction: releases taskID back to NEW with a resume reservation for
 * this worker, and claims the offered candidate task — returning its
 * FormDetails. If the candidate is no longer claimable, the offer is marked
 * expired and no state on the current session changes. On reject, the current
 * session is left untouched and 204 is returned.
 *
 */
export const respondToInterruptionOfferMutation = (options?: Partial<Options<RespondToInterruptionOfferData>>): UseMutationOptions<RespondToInterruptionOfferResponse, DefaultError, Options<RespondToInterruptionOfferData>> => {
    const mutationOptions: UseMutationOptions<RespondToInterruptionOfferResponse, DefaultError, Options<RespondToInterruptionOfferData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await respondToInterruptionOffer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTaskByIdQueryKey = (options: Options<GetTaskByIdData>) => createQueryKey('getTaskById', options);

/**
 * Get a task by ID
 */
export const getTaskByIdOptions = (options: Options<GetTaskByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getTaskById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getTaskByIdQueryKey(options)
    });
};

/**
 * Complete a task
 */
export const completeUserTaskMutation = (options?: Partial<Options<CompleteUserTaskData>>): UseMutationOptions<CompleteUserTaskResponse, DefaultError, Options<CompleteUserTaskData>> => {
    const mutationOptions: UseMutationOptions<CompleteUserTaskResponse, DefaultError, Options<CompleteUserTaskData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await completeUserTask({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const recordTaskValidationAckQueryKey = (options: Options<RecordTaskValidationAckData>) => createQueryKey('recordTaskValidationAck', options);

/**
 * Acknowledge heuristic validation errors for a task
 *
 * Allows a Labeller or Reviewer assigned to a task to acknowledge heuristic-rule
 * errors raised against the work item. Creates a single feedback row with type ACK
 * and status COMPLETED. Feedback may include document-level comments and/or
 * per-field acknowledgements.
 *
 */
export const recordTaskValidationAckOptions = (options: Options<RecordTaskValidationAckData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await recordTaskValidationAck({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: recordTaskValidationAckQueryKey(options)
    });
};

/**
 * Acknowledge heuristic validation errors for a task
 *
 * Allows a Labeller or Reviewer assigned to a task to acknowledge heuristic-rule
 * errors raised against the work item. Creates a single feedback row with type ACK
 * and status COMPLETED. Feedback may include document-level comments and/or
 * per-field acknowledgements.
 *
 */
export const recordTaskValidationAckMutation = (options?: Partial<Options<RecordTaskValidationAckData>>): UseMutationOptions<RecordTaskValidationAckResponse, DefaultError, Options<RecordTaskValidationAckData>> => {
    const mutationOptions: UseMutationOptions<RecordTaskValidationAckResponse, DefaultError, Options<RecordTaskValidationAckData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await recordTaskValidationAck({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTaskDraftQueryKey = (options: Options<GetTaskDraftData>) => createQueryKey('getTaskDraft', options);

/**
 * Get the latest saved in-progress form output for a task
 *
 * Returns the most recently updated live (non-soft-deleted) draft
 * FormOutput stashed for the given task, regardless of which worker
 * saved it. Drafts are task-scoped on read so that when a task changes
 * hands, the incoming worker inherits the outgoing worker's in-flight
 * state and no work is lost across reassignment. Returns 404 when no
 * live draft exists for the task — e.g. one has never been saved, or
 * it has already been consumed on resume.
 *
 */
export const getTaskDraftOptions = (options: Options<GetTaskDraftData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getTaskDraft({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getTaskDraftQueryKey(options)
    });
};

/**
 * Save a draft of the in-progress form output for a task
 *
 * Stashes the caller's in-flight FormOutput for a task they currently
 * have assigned, without completing it or touching the task's own
 * form_output. At most one live draft is kept per (task, worker) — a
 * repeated save overwrites the previous draft. Draft consumption
 * (loading + soft-delete on resume) happens automatically the next
 * time the caller is re-assigned this task.
 *
 */
export const saveTaskDraftMutation = (options?: Partial<Options<SaveTaskDraftData>>): UseMutationOptions<SaveTaskDraftResponse, DefaultError, Options<SaveTaskDraftData>> => {
    const mutationOptions: UseMutationOptions<SaveTaskDraftResponse, DefaultError, Options<SaveTaskDraftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveTaskDraft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const assignTaskToUserQueryKey = (options?: Options<AssignTaskToUserData>) => createQueryKey('assignTaskToUser', options);

/**
 * Assign task to user
 */
export const assignTaskToUserOptions = (options?: Options<AssignTaskToUserData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await assignTaskToUser({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: assignTaskToUserQueryKey(options)
    });
};

/**
 * Assign task to user
 */
export const assignTaskToUserMutation = (options?: Partial<Options<AssignTaskToUserData>>): UseMutationOptions<AssignTaskToUserResponse, DefaultError, Options<AssignTaskToUserData>> => {
    const mutationOptions: UseMutationOptions<AssignTaskToUserResponse, DefaultError, Options<AssignTaskToUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assignTaskToUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const countTasksQueryKey = (options: Options<CountTasksData>) => createQueryKey('countTasks', options);

/**
 * Count tasks under a project with optional filters
 */
export const countTasksOptions = (options: Options<CountTasksData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await countTasks({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: countTasksQueryKey(options)
    });
};

export const listTasksQueryKey = (options: Options<ListTasksData>) => createQueryKey('listTasks', options);

/**
 * List tasks
 */
export const listTasksOptions = (options: Options<ListTasksData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listTasks({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listTasksQueryKey(options)
    });
};

export const listTasksInfiniteQueryKey = (options: Options<ListTasksData>): QueryKey<Options<ListTasksData>> => createQueryKey('listTasks', options, true);

/**
 * List tasks
 */
export const listTasksInfiniteOptions = (options: Options<ListTasksData>) => {
    return infiniteQueryOptions<ListTasksResponse, DefaultError, InfiniteData<ListTasksResponse>, QueryKey<Options<ListTasksData>>, string | Pick<QueryKey<Options<ListTasksData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListTasksData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listTasks({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listTasksInfiniteQueryKey(options)
    });
};

export const takeoverTaskQueryKey = (options: Options<TakeoverTaskData>) => createQueryKey('takeoverTask', options);

/**
 * Admin/Owner takeover of a task (Manage Mode)
 *
 * Allows an Admin or Owner to atomically unassign any existing assignee and
 * claim a NEW or IN_PROGRESS task for themselves. Returns FormDetails so the
 * task screen can be opened immediately. Restricted to project owners and
 * administrators via project:project_manage.
 *
 */
export const takeoverTaskOptions = (options: Options<TakeoverTaskData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await takeoverTask({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: takeoverTaskQueryKey(options)
    });
};

/**
 * Admin/Owner takeover of a task (Manage Mode)
 *
 * Allows an Admin or Owner to atomically unassign any existing assignee and
 * claim a NEW or IN_PROGRESS task for themselves. Returns FormDetails so the
 * task screen can be opened immediately. Restricted to project owners and
 * administrators via project:project_manage.
 *
 */
export const takeoverTaskMutation = (options?: Partial<Options<TakeoverTaskData>>): UseMutationOptions<TakeoverTaskResponse, DefaultError, Options<TakeoverTaskData>> => {
    const mutationOptions: UseMutationOptions<TakeoverTaskResponse, DefaultError, Options<TakeoverTaskData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await takeoverTask({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unassign tasks
 */
export const unassignTasksMutation = (options?: Partial<Options<UnassignTasksData>>): UseMutationOptions<unknown, DefaultError, Options<UnassignTasksData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<UnassignTasksData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await unassignTasks({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const forceCompleteTaskQueryKey = (options: Options<ForceCompleteTaskData>) => createQueryKey('forceCompleteTask', options);

/**
 * Force complete a stalled task (Admin only)
 *
 * Allows a System Administrator to forcibly transition a stalled task from
 * NEW or IN_PROGRESS to DONE, attributing the completion to a specified
 * Cloudworker. Triggers the same downstream workflow signals as a normal
 * task completion. If the task was already completed by an automated signal,
 * the operation returns success (idempotent/race-condition safe).
 *
 */
export const forceCompleteTaskOptions = (options: Options<ForceCompleteTaskData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await forceCompleteTask({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: forceCompleteTaskQueryKey(options)
    });
};

/**
 * Force complete a stalled task (Admin only)
 *
 * Allows a System Administrator to forcibly transition a stalled task from
 * NEW or IN_PROGRESS to DONE, attributing the completion to a specified
 * Cloudworker. Triggers the same downstream workflow signals as a normal
 * task completion. If the task was already completed by an automated signal,
 * the operation returns success (idempotent/race-condition safe).
 *
 */
export const forceCompleteTaskMutation = (options?: Partial<Options<ForceCompleteTaskData>>): UseMutationOptions<ForceCompleteTaskResponse, DefaultError, Options<ForceCompleteTaskData>> => {
    const mutationOptions: UseMutationOptions<ForceCompleteTaskResponse, DefaultError, Options<ForceCompleteTaskData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await forceCompleteTask({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const submitBulkForceCompleteJobQueryKey = (options: Options<SubmitBulkForceCompleteJobData>) => createQueryKey('submitBulkForceCompleteJob', options);

/**
 * Submit a bulk force complete job (Admin only)
 *
 * Enqueues an asynchronous job that force-completes many tasks in one action.
 * Returns a jobId immediately; the caller polls the status endpoint for
 * progress and outcome. See docs/design/2026-08-24-bulk-force-complete.md.
 *
 */
export const submitBulkForceCompleteJobOptions = (options: Options<SubmitBulkForceCompleteJobData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await submitBulkForceCompleteJob({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: submitBulkForceCompleteJobQueryKey(options)
    });
};

/**
 * Submit a bulk force complete job (Admin only)
 *
 * Enqueues an asynchronous job that force-completes many tasks in one action.
 * Returns a jobId immediately; the caller polls the status endpoint for
 * progress and outcome. See docs/design/2026-08-24-bulk-force-complete.md.
 *
 */
export const submitBulkForceCompleteJobMutation = (options?: Partial<Options<SubmitBulkForceCompleteJobData>>): UseMutationOptions<SubmitBulkForceCompleteJobResponse, DefaultError, Options<SubmitBulkForceCompleteJobData>> => {
    const mutationOptions: UseMutationOptions<SubmitBulkForceCompleteJobResponse, DefaultError, Options<SubmitBulkForceCompleteJobData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await submitBulkForceCompleteJob({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getBulkForceCompleteJobQueryKey = (options: Options<GetBulkForceCompleteJobData>) => createQueryKey('getBulkForceCompleteJob', options);

/**
 * Get a bulk force complete job status (Admin only)
 */
export const getBulkForceCompleteJobOptions = (options: Options<GetBulkForceCompleteJobData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getBulkForceCompleteJob({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getBulkForceCompleteJobQueryKey(options)
    });
};

export const bulkUnassignTasksQueryKey = (options: Options<BulkUnassignTasksData>) => createQueryKey('bulkUnassignTasks', options);

/**
 * Bulk unassign tasks (Admin only)
 *
 * Unassigns many IN_PROGRESS tasks in one action, either by explicit task
 * IDs or by a server-resolved filter. Resolves and validates the scope,
 * then unassigns eligible tasks and returns 202 with a job ID; per-item
 * results are recorded for audit even though unassign settles synchronously.
 *
 */
export const bulkUnassignTasksOptions = (options: Options<BulkUnassignTasksData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await bulkUnassignTasks({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: bulkUnassignTasksQueryKey(options)
    });
};

/**
 * Bulk unassign tasks (Admin only)
 *
 * Unassigns many IN_PROGRESS tasks in one action, either by explicit task
 * IDs or by a server-resolved filter. Resolves and validates the scope,
 * then unassigns eligible tasks and returns 202 with a job ID; per-item
 * results are recorded for audit even though unassign settles synchronously.
 *
 */
export const bulkUnassignTasksMutation = (options?: Partial<Options<BulkUnassignTasksData>>): UseMutationOptions<BulkUnassignTasksResponse, DefaultError, Options<BulkUnassignTasksData>> => {
    const mutationOptions: UseMutationOptions<BulkUnassignTasksResponse, DefaultError, Options<BulkUnassignTasksData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bulkUnassignTasks({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTaskViewQueryKey = (options: Options<GetTaskViewData>) => createQueryKey('getTaskView', options);

/**
 * Get a read-only view of a completed task (form and submitted inference)
 */
export const getTaskViewOptions = (options: Options<GetTaskViewData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getTaskView({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getTaskViewQueryKey(options)
    });
};

export const listUserRolesQueryKey = (options: Options<ListUserRolesData>) => createQueryKey('listUserRoles', options);

/**
 * List User Roles
 */
export const listUserRolesOptions = (options: Options<ListUserRolesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listUserRoles({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listUserRolesQueryKey(options)
    });
};

export const assignRolesToUsersQueryKey = (options: Options<AssignRolesToUsersData>) => createQueryKey('assignRolesToUsers', options);

/**
 * Assign Roles to Users
 */
export const assignRolesToUsersOptions = (options: Options<AssignRolesToUsersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await assignRolesToUsers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: assignRolesToUsersQueryKey(options)
    });
};

/**
 * Assign Roles to Users
 */
export const assignRolesToUsersMutation = (options?: Partial<Options<AssignRolesToUsersData>>): UseMutationOptions<unknown, DefaultError, Options<AssignRolesToUsersData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<AssignRolesToUsersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assignRolesToUsers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Roles from Users
 */
export const updateRolesFromUsersMutation = (options?: Partial<Options<UpdateRolesFromUsersData>>): UseMutationOptions<unknown, DefaultError, Options<UpdateRolesFromUsersData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<UpdateRolesFromUsersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateRolesFromUsers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listPlatformAdminsQueryKey = (options?: Options<ListPlatformAdminsData>) => createQueryKey('listPlatformAdmins', options);

/**
 * List Platform Admins
 */
export const listPlatformAdminsOptions = (options?: Options<ListPlatformAdminsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listPlatformAdmins({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listPlatformAdminsQueryKey(options)
    });
};

/**
 * Revoke Platform Admin Role from User
 */
export const revokePlatformAdminRoleMutation = (options?: Partial<Options<RevokePlatformAdminRoleData>>): UseMutationOptions<unknown, DefaultError, Options<RevokePlatformAdminRoleData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<RevokePlatformAdminRoleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await revokePlatformAdminRole({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const assignPlatformAdminRoleQueryKey = (options: Options<AssignPlatformAdminRoleData>) => createQueryKey('assignPlatformAdminRole', options);

/**
 * Assign Platform Admin Role to User
 */
export const assignPlatformAdminRoleOptions = (options: Options<AssignPlatformAdminRoleData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await assignPlatformAdminRole({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: assignPlatformAdminRoleQueryKey(options)
    });
};

/**
 * Assign Platform Admin Role to User
 */
export const assignPlatformAdminRoleMutation = (options?: Partial<Options<AssignPlatformAdminRoleData>>): UseMutationOptions<unknown, DefaultError, Options<AssignPlatformAdminRoleData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<AssignPlatformAdminRoleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assignPlatformAdminRole({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const processConsensusSamplerQueryKey = (options: Options<ProcessConsensusSamplerData>) => createQueryKey('processConsensusSampler', options);

/**
 * Process Samplers
 */
export const processConsensusSamplerOptions = (options: Options<ProcessConsensusSamplerData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await processConsensusSampler({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: processConsensusSamplerQueryKey(options)
    });
};

/**
 * Process Samplers
 */
export const processConsensusSamplerMutation = (options?: Partial<Options<ProcessConsensusSamplerData>>): UseMutationOptions<ProcessConsensusSamplerResponse, DefaultError, Options<ProcessConsensusSamplerData>> => {
    const mutationOptions: UseMutationOptions<ProcessConsensusSamplerResponse, DefaultError, Options<ProcessConsensusSamplerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await processConsensusSampler({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const processRandomSamplerQueryKey = (options: Options<ProcessRandomSamplerData>) => createQueryKey('processRandomSampler', options);

/**
 * Process Samplers
 */
export const processRandomSamplerOptions = (options: Options<ProcessRandomSamplerData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await processRandomSampler({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: processRandomSamplerQueryKey(options)
    });
};

/**
 * Process Samplers
 */
export const processRandomSamplerMutation = (options?: Partial<Options<ProcessRandomSamplerData>>): UseMutationOptions<ProcessRandomSamplerResponse, DefaultError, Options<ProcessRandomSamplerData>> => {
    const mutationOptions: UseMutationOptions<ProcessRandomSamplerResponse, DefaultError, Options<ProcessRandomSamplerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await processRandomSampler({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createQcSamplingPolicyQueryKey = (options: Options<CreateQcSamplingPolicyData>) => createQueryKey('createQcSamplingPolicy', options);

/**
 * Create a QC sampling policy for a project
 */
export const createQcSamplingPolicyOptions = (options: Options<CreateQcSamplingPolicyData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createQcSamplingPolicy({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createQcSamplingPolicyQueryKey(options)
    });
};

/**
 * Create a QC sampling policy for a project
 */
export const createQcSamplingPolicyMutation = (options?: Partial<Options<CreateQcSamplingPolicyData>>): UseMutationOptions<CreateQcSamplingPolicyResponse, DefaultError, Options<CreateQcSamplingPolicyData>> => {
    const mutationOptions: UseMutationOptions<CreateQcSamplingPolicyResponse, DefaultError, Options<CreateQcSamplingPolicyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createQcSamplingPolicy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getQcSamplingPolicyQueryKey = (options: Options<GetQcSamplingPolicyData>) => createQueryKey('getQcSamplingPolicy', options);

/**
 * Get a QC sampling policy by ID
 */
export const getQcSamplingPolicyOptions = (options: Options<GetQcSamplingPolicyData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getQcSamplingPolicy({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getQcSamplingPolicyQueryKey(options)
    });
};

/**
 * Update a QC sampling policy
 */
export const updateQcSamplingPolicyMutation = (options?: Partial<Options<UpdateQcSamplingPolicyData>>): UseMutationOptions<UpdateQcSamplingPolicyResponse, DefaultError, Options<UpdateQcSamplingPolicyData>> => {
    const mutationOptions: UseMutationOptions<UpdateQcSamplingPolicyResponse, DefaultError, Options<UpdateQcSamplingPolicyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateQcSamplingPolicy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listServiceAccountsQueryKey = (options: Options<ListServiceAccountsData>) => createQueryKey('listServiceAccounts', options);

/**
 * List service accounts for a space
 */
export const listServiceAccountsOptions = (options: Options<ListServiceAccountsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listServiceAccounts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listServiceAccountsQueryKey(options)
    });
};

export const createServiceAccountV2QueryKey = (options: Options<CreateServiceAccountV2Data>) => createQueryKey('createServiceAccountV2', options);

/**
 * Create a service account in a space
 */
export const createServiceAccountV2Options = (options: Options<CreateServiceAccountV2Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createServiceAccountV2({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createServiceAccountV2QueryKey(options)
    });
};

/**
 * Create a service account in a space
 */
export const createServiceAccountV2Mutation = (options?: Partial<Options<CreateServiceAccountV2Data>>): UseMutationOptions<CreateServiceAccountV2Response, DefaultError, Options<CreateServiceAccountV2Data>> => {
    const mutationOptions: UseMutationOptions<CreateServiceAccountV2Response, DefaultError, Options<CreateServiceAccountV2Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createServiceAccountV2({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a service account and revoke its API key
 */
export const deleteServiceAccountMutation = (options?: Partial<Options<DeleteServiceAccountData>>): UseMutationOptions<DeleteServiceAccountResponse, DefaultError, Options<DeleteServiceAccountData>> => {
    const mutationOptions: UseMutationOptions<DeleteServiceAccountResponse, DefaultError, Options<DeleteServiceAccountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteServiceAccount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getServiceAccountQueryKey = (options: Options<GetServiceAccountData>) => createQueryKey('getServiceAccount', options);

/**
 * Get a specific service account
 */
export const getServiceAccountOptions = (options: Options<GetServiceAccountData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getServiceAccount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getServiceAccountQueryKey(options)
    });
};

export const rotateServiceAccountApiKeyQueryKey = (options: Options<RotateServiceAccountApiKeyData>) => createQueryKey('rotateServiceAccountApiKey', options);

/**
 * Rotate the API key for a service account
 */
export const rotateServiceAccountApiKeyOptions = (options: Options<RotateServiceAccountApiKeyData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await rotateServiceAccountApiKey({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: rotateServiceAccountApiKeyQueryKey(options)
    });
};

/**
 * Rotate the API key for a service account
 */
export const rotateServiceAccountApiKeyMutation = (options?: Partial<Options<RotateServiceAccountApiKeyData>>): UseMutationOptions<RotateServiceAccountApiKeyResponse, DefaultError, Options<RotateServiceAccountApiKeyData>> => {
    const mutationOptions: UseMutationOptions<RotateServiceAccountApiKeyResponse, DefaultError, Options<RotateServiceAccountApiKeyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rotateServiceAccountApiKey({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getProjectSettingQueryKey = (options: Options<GetProjectSettingData>) => createQueryKey('getProjectSetting', options);

/**
 * Get the setting for a project
 */
export const getProjectSettingOptions = (options: Options<GetProjectSettingData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getProjectSetting({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getProjectSettingQueryKey(options)
    });
};

/**
 * Upsert the setting for a project
 */
export const upsertProjectSettingMutation = (options?: Partial<Options<UpsertProjectSettingData>>): UseMutationOptions<UpsertProjectSettingResponse, DefaultError, Options<UpsertProjectSettingData>> => {
    const mutationOptions: UseMutationOptions<UpsertProjectSettingResponse, DefaultError, Options<UpsertProjectSettingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await upsertProjectSetting({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getProjectWorkflowSettingQueryKey = (options: Options<GetProjectWorkflowSettingData>) => createQueryKey('getProjectWorkflowSetting', options);

/**
 * Get a workflow setting by ID
 */
export const getProjectWorkflowSettingOptions = (options: Options<GetProjectWorkflowSettingData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getProjectWorkflowSetting({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getProjectWorkflowSettingQueryKey(options)
    });
};

/**
 * Upsert a workflow setting by ID
 */
export const upsertProjectWorkflowSettingMutation = (options?: Partial<Options<UpsertProjectWorkflowSettingData>>): UseMutationOptions<UpsertProjectWorkflowSettingResponse, DefaultError, Options<UpsertProjectWorkflowSettingData>> => {
    const mutationOptions: UseMutationOptions<UpsertProjectWorkflowSettingResponse, DefaultError, Options<UpsertProjectWorkflowSettingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await upsertProjectWorkflowSetting({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSpaceSettingQueryKey = (options: Options<GetSpaceSettingData>) => createQueryKey('getSpaceSetting', options);

/**
 * Get the deduplication and import setting for a space
 */
export const getSpaceSettingOptions = (options: Options<GetSpaceSettingData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSpaceSetting({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getSpaceSettingQueryKey(options)
    });
};

/**
 * Upsert the deduplication and import setting for a space
 */
export const upsertSpaceSettingMutation = (options?: Partial<Options<UpsertSpaceSettingData>>): UseMutationOptions<UpsertSpaceSettingResponse, DefaultError, Options<UpsertSpaceSettingData>> => {
    const mutationOptions: UseMutationOptions<UpsertSpaceSettingResponse, DefaultError, Options<UpsertSpaceSettingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await upsertSpaceSetting({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSowConfigQueryKey = (options: Options<GetSowConfigData>) => createQueryKey('getSowConfig', options);

/**
 * Get SOW configuration for a project
 */
export const getSowConfigOptions = (options: Options<GetSowConfigData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSowConfig({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getSowConfigQueryKey(options)
    });
};

export const createSowConfigQueryKey = (options: Options<CreateSowConfigData>) => createQueryKey('createSowConfig', options);

/**
 * Create SOW configuration for a project
 */
export const createSowConfigOptions = (options: Options<CreateSowConfigData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createSowConfig({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createSowConfigQueryKey(options)
    });
};

/**
 * Create SOW configuration for a project
 */
export const createSowConfigMutation = (options?: Partial<Options<CreateSowConfigData>>): UseMutationOptions<CreateSowConfigResponse, DefaultError, Options<CreateSowConfigData>> => {
    const mutationOptions: UseMutationOptions<CreateSowConfigResponse, DefaultError, Options<CreateSowConfigData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createSowConfig({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update SOW configuration for a project
 */
export const updateSowConfigMutation = (options?: Partial<Options<UpdateSowConfigData>>): UseMutationOptions<UpdateSowConfigResponse, DefaultError, Options<UpdateSowConfigData>> => {
    const mutationOptions: UseMutationOptions<UpdateSowConfigResponse, DefaultError, Options<UpdateSowConfigData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateSowConfig({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSowConfigSlaAlertConfigQueryKey = (options: Options<GetSowConfigSlaAlertConfigData>) => createQueryKey('getSowConfigSlaAlertConfig', options);

/**
 * Get the SLA alert configuration for a SOW config and SLA type
 */
export const getSowConfigSlaAlertConfigOptions = (options: Options<GetSowConfigSlaAlertConfigData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSowConfigSlaAlertConfig({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getSowConfigSlaAlertConfigQueryKey(options)
    });
};

/**
 * Create or update the SLA alert configuration for a SOW config and SLA type
 */
export const upsertSowConfigSlaAlertConfigMutation = (options?: Partial<Options<UpsertSowConfigSlaAlertConfigData>>): UseMutationOptions<UpsertSowConfigSlaAlertConfigResponse, DefaultError, Options<UpsertSowConfigSlaAlertConfigData>> => {
    const mutationOptions: UseMutationOptions<UpsertSowConfigSlaAlertConfigResponse, DefaultError, Options<UpsertSowConfigSlaAlertConfigData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await upsertSowConfigSlaAlertConfig({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listSpacesQueryKey = (options: Options<ListSpacesData>) => createQueryKey('listSpaces', options);

/**
 * List all spaces
 */
export const listSpacesOptions = (options: Options<ListSpacesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listSpaces({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listSpacesQueryKey(options)
    });
};

export const createSpaceQueryKey = (options: Options<CreateSpaceData>) => createQueryKey('createSpace', options);

/**
 * Create a new space
 */
export const createSpaceOptions = (options: Options<CreateSpaceData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createSpace({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createSpaceQueryKey(options)
    });
};

/**
 * Create a new space
 */
export const createSpaceMutation = (options?: Partial<Options<CreateSpaceData>>): UseMutationOptions<CreateSpaceResponse, DefaultError, Options<CreateSpaceData>> => {
    const mutationOptions: UseMutationOptions<CreateSpaceResponse, DefaultError, Options<CreateSpaceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createSpace({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Soft deletes a space
 */
export const deleteSpaceMutation = (options?: Partial<Options<DeleteSpaceData>>): UseMutationOptions<unknown, DefaultError, Options<DeleteSpaceData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeleteSpaceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteSpace({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSpaceByIdQueryKey = (options: Options<GetSpaceByIdData>) => createQueryKey('getSpaceById', options);

/**
 * Get a space by ID
 */
export const getSpaceByIdOptions = (options: Options<GetSpaceByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSpaceById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getSpaceByIdQueryKey(options)
    });
};

/**
 * Update a space
 */
export const updateSpaceMutation = (options?: Partial<Options<UpdateSpaceData>>): UseMutationOptions<UpdateSpaceResponse, DefaultError, Options<UpdateSpaceData>> => {
    const mutationOptions: UseMutationOptions<UpdateSpaceResponse, DefaultError, Options<UpdateSpaceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateSpace({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listSplitsQueryKey = (options: Options<ListSplitsData>) => createQueryKey('listSplits', options);

/**
 * List data splits
 */
export const listSplitsOptions = (options: Options<ListSplitsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listSplits({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listSplitsQueryKey(options)
    });
};

export const listSplitsInfiniteQueryKey = (options: Options<ListSplitsData>): QueryKey<Options<ListSplitsData>> => createQueryKey('listSplits', options, true);

/**
 * List data splits
 */
export const listSplitsInfiniteOptions = (options: Options<ListSplitsData>) => {
    return infiniteQueryOptions<ListSplitsResponse2, DefaultError, InfiniteData<ListSplitsResponse2>, QueryKey<Options<ListSplitsData>>, string | Pick<QueryKey<Options<ListSplitsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListSplitsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listSplits({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listSplitsInfiniteQueryKey(options)
    });
};

export const createSplitQueryKey = (options: Options<CreateSplitData>) => createQueryKey('createSplit', options);

/**
 * Create a data split
 */
export const createSplitOptions = (options: Options<CreateSplitData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createSplit({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createSplitQueryKey(options)
    });
};

/**
 * Create a data split
 */
export const createSplitMutation = (options?: Partial<Options<CreateSplitData>>): UseMutationOptions<CreateSplitResponse2, DefaultError, Options<CreateSplitData>> => {
    const mutationOptions: UseMutationOptions<CreateSplitResponse2, DefaultError, Options<CreateSplitData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createSplit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSplitQueryKey = (options: Options<GetSplitData>) => createQueryKey('getSplit', options);

/**
 * Get a data split
 */
export const getSplitOptions = (options: Options<GetSplitData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSplit({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getSplitQueryKey(options)
    });
};

export const listSystemTaxonomiesQueryKey = (options?: Options<ListSystemTaxonomiesData>) => createQueryKey('listSystemTaxonomies', options);

/**
 * List all system taxonomies (metadata only)
 */
export const listSystemTaxonomiesOptions = (options?: Options<ListSystemTaxonomiesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listSystemTaxonomies({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listSystemTaxonomiesQueryKey(options)
    });
};

export const listSystemTaxonomiesInfiniteQueryKey = (options?: Options<ListSystemTaxonomiesData>): QueryKey<Options<ListSystemTaxonomiesData>> => createQueryKey('listSystemTaxonomies', options, true);

/**
 * List all system taxonomies (metadata only)
 */
export const listSystemTaxonomiesInfiniteOptions = (options?: Options<ListSystemTaxonomiesData>) => {
    return infiniteQueryOptions<ListSystemTaxonomiesResponse, DefaultError, InfiniteData<ListSystemTaxonomiesResponse>, QueryKey<Options<ListSystemTaxonomiesData>>, string | Pick<QueryKey<Options<ListSystemTaxonomiesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListSystemTaxonomiesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listSystemTaxonomies({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listSystemTaxonomiesInfiniteQueryKey(options)
    });
};

export const getSystemTaxonomyQueryKey = (options: Options<GetSystemTaxonomyData>) => createQueryKey('getSystemTaxonomy', options);

/**
 * Get system taxonomy (including current version)
 */
export const getSystemTaxonomyOptions = (options: Options<GetSystemTaxonomyData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSystemTaxonomy({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getSystemTaxonomyQueryKey(options)
    });
};

export const listTaxonomiesQueryKey = (options: Options<ListTaxonomiesData>) => createQueryKey('listTaxonomies', options);

/**
 * List all taxonomies (metadata only)
 */
export const listTaxonomiesOptions = (options: Options<ListTaxonomiesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listTaxonomies({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listTaxonomiesQueryKey(options)
    });
};

export const listTaxonomiesInfiniteQueryKey = (options: Options<ListTaxonomiesData>): QueryKey<Options<ListTaxonomiesData>> => createQueryKey('listTaxonomies', options, true);

/**
 * List all taxonomies (metadata only)
 */
export const listTaxonomiesInfiniteOptions = (options: Options<ListTaxonomiesData>) => {
    return infiniteQueryOptions<ListTaxonomiesResponse, DefaultError, InfiniteData<ListTaxonomiesResponse>, QueryKey<Options<ListTaxonomiesData>>, string | Pick<QueryKey<Options<ListTaxonomiesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListTaxonomiesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listTaxonomies({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listTaxonomiesInfiniteQueryKey(options)
    });
};

export const createTaxonomyQueryKey = (options: Options<CreateTaxonomyData>) => createQueryKey('createTaxonomy', options);

/**
 * Create a new taxonomy (creates version 1)
 */
export const createTaxonomyOptions = (options: Options<CreateTaxonomyData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createTaxonomy({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createTaxonomyQueryKey(options)
    });
};

/**
 * Create a new taxonomy (creates version 1)
 */
export const createTaxonomyMutation = (options?: Partial<Options<CreateTaxonomyData>>): UseMutationOptions<CreateTaxonomyResponse, DefaultError, Options<CreateTaxonomyData>> => {
    const mutationOptions: UseMutationOptions<CreateTaxonomyResponse, DefaultError, Options<CreateTaxonomyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createTaxonomy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a taxonomy (including all its versions)
 */
export const deleteTaxonomyMutation = (options?: Partial<Options<DeleteTaxonomyData>>): UseMutationOptions<DeleteTaxonomyResponse, DefaultError, Options<DeleteTaxonomyData>> => {
    const mutationOptions: UseMutationOptions<DeleteTaxonomyResponse, DefaultError, Options<DeleteTaxonomyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteTaxonomy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTaxonomyQueryKey = (options: Options<GetTaxonomyData>) => createQueryKey('getTaxonomy', options);

/**
 * Get taxonomy (including current version)
 */
export const getTaxonomyOptions = (options: Options<GetTaxonomyData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getTaxonomy({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getTaxonomyQueryKey(options)
    });
};

/**
 * Update taxonomy (metadata only)
 */
export const updateTaxonomyMutation = (options?: Partial<Options<UpdateTaxonomyData>>): UseMutationOptions<UpdateTaxonomyResponse, DefaultError, Options<UpdateTaxonomyData>> => {
    const mutationOptions: UseMutationOptions<UpdateTaxonomyResponse, DefaultError, Options<UpdateTaxonomyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateTaxonomy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listTaxonomyVersionsQueryKey = (options: Options<ListTaxonomyVersionsData>) => createQueryKey('listTaxonomyVersions', options);

/**
 * List all taxonomy versions (metadata only)
 */
export const listTaxonomyVersionsOptions = (options: Options<ListTaxonomyVersionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listTaxonomyVersions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listTaxonomyVersionsQueryKey(options)
    });
};

export const listTaxonomyVersionsInfiniteQueryKey = (options: Options<ListTaxonomyVersionsData>): QueryKey<Options<ListTaxonomyVersionsData>> => createQueryKey('listTaxonomyVersions', options, true);

/**
 * List all taxonomy versions (metadata only)
 */
export const listTaxonomyVersionsInfiniteOptions = (options: Options<ListTaxonomyVersionsData>) => {
    return infiniteQueryOptions<ListTaxonomyVersionsResponse, DefaultError, InfiniteData<ListTaxonomyVersionsResponse>, QueryKey<Options<ListTaxonomyVersionsData>>, string | Pick<QueryKey<Options<ListTaxonomyVersionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListTaxonomyVersionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listTaxonomyVersions({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listTaxonomyVersionsInfiniteQueryKey(options)
    });
};

export const createTaxonomyVersionQueryKey = (options: Options<CreateTaxonomyVersionData>) => createQueryKey('createTaxonomyVersion', options);

/**
 * Create a new version of an existing taxonomy
 */
export const createTaxonomyVersionOptions = (options: Options<CreateTaxonomyVersionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createTaxonomyVersion({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createTaxonomyVersionQueryKey(options)
    });
};

/**
 * Create a new version of an existing taxonomy
 */
export const createTaxonomyVersionMutation = (options?: Partial<Options<CreateTaxonomyVersionData>>): UseMutationOptions<CreateTaxonomyVersionResponse, DefaultError, Options<CreateTaxonomyVersionData>> => {
    const mutationOptions: UseMutationOptions<CreateTaxonomyVersionResponse, DefaultError, Options<CreateTaxonomyVersionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createTaxonomyVersion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTaxonomyVersionQueryKey = (options: Options<GetTaxonomyVersionData>) => createQueryKey('getTaxonomyVersion', options);

/**
 * Get a specific version of a taxonomy
 */
export const getTaxonomyVersionOptions = (options: Options<GetTaxonomyVersionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getTaxonomyVersion({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getTaxonomyVersionQueryKey(options)
    });
};

/**
 * Update taxonomy version (metadata only)
 */
export const updateTaxonomyVersionMutation = (options?: Partial<Options<UpdateTaxonomyVersionData>>): UseMutationOptions<UpdateTaxonomyVersionResponse, DefaultError, Options<UpdateTaxonomyVersionData>> => {
    const mutationOptions: UseMutationOptions<UpdateTaxonomyVersionResponse, DefaultError, Options<UpdateTaxonomyVersionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateTaxonomyVersion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const setTaxonomyVersionCurrentQueryKey = (options: Options<SetTaxonomyVersionCurrentData>) => createQueryKey('setTaxonomyVersionCurrent', options);

/**
 * Set this taxonomy version as the current version
 */
export const setTaxonomyVersionCurrentOptions = (options: Options<SetTaxonomyVersionCurrentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await setTaxonomyVersionCurrent({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: setTaxonomyVersionCurrentQueryKey(options)
    });
};

/**
 * Set this taxonomy version as the current version
 */
export const setTaxonomyVersionCurrentMutation = (options?: Partial<Options<SetTaxonomyVersionCurrentData>>): UseMutationOptions<SetTaxonomyVersionCurrentResponse, DefaultError, Options<SetTaxonomyVersionCurrentData>> => {
    const mutationOptions: UseMutationOptions<SetTaxonomyVersionCurrentResponse, DefaultError, Options<SetTaxonomyVersionCurrentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setTaxonomyVersionCurrent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listUserGroupsQueryKey = (options: Options<ListUserGroupsData>) => createQueryKey('listUserGroups', options);

/**
 * List all groups in a project
 */
export const listUserGroupsOptions = (options: Options<ListUserGroupsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listUserGroups({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listUserGroupsQueryKey(options)
    });
};

export const createUserGroupQueryKey = (options: Options<CreateUserGroupData>) => createQueryKey('createUserGroup', options);

/**
 * Create a new user group
 */
export const createUserGroupOptions = (options: Options<CreateUserGroupData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createUserGroup({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createUserGroupQueryKey(options)
    });
};

/**
 * Create a new user group
 */
export const createUserGroupMutation = (options?: Partial<Options<CreateUserGroupData>>): UseMutationOptions<CreateUserGroupResponse, DefaultError, Options<CreateUserGroupData>> => {
    const mutationOptions: UseMutationOptions<CreateUserGroupResponse, DefaultError, Options<CreateUserGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createUserGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update an existing user group
 */
export const updateUserGroupMutation = (options?: Partial<Options<UpdateUserGroupData>>): UseMutationOptions<UpdateUserGroupResponse, DefaultError, Options<UpdateUserGroupData>> => {
    const mutationOptions: UseMutationOptions<UpdateUserGroupResponse, DefaultError, Options<UpdateUserGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateUserGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk unassign users from a group
 */
export const bulkUnassignUsersFromGroupMutation = (options?: Partial<Options<BulkUnassignUsersFromGroupData>>): UseMutationOptions<BulkUnassignUsersFromGroupResponse, DefaultError, Options<BulkUnassignUsersFromGroupData>> => {
    const mutationOptions: UseMutationOptions<BulkUnassignUsersFromGroupResponse, DefaultError, Options<BulkUnassignUsersFromGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bulkUnassignUsersFromGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listUserGroupMembersQueryKey = (options: Options<ListUserGroupMembersData>) => createQueryKey('listUserGroupMembers', options);

/**
 * List all users in a group
 *
 * Returns the members of the group. Pagination is opt-in: when none of `limit`, `cursor` or `page` is supplied every matching member is returned and `meta` is omitted.
 */
export const listUserGroupMembersOptions = (options: Options<ListUserGroupMembersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listUserGroupMembers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listUserGroupMembersQueryKey(options)
    });
};

export const listUserGroupMembersInfiniteQueryKey = (options: Options<ListUserGroupMembersData>): QueryKey<Options<ListUserGroupMembersData>> => createQueryKey('listUserGroupMembers', options, true);

/**
 * List all users in a group
 *
 * Returns the members of the group. Pagination is opt-in: when none of `limit`, `cursor` or `page` is supplied every matching member is returned and `meta` is omitted.
 */
export const listUserGroupMembersInfiniteOptions = (options: Options<ListUserGroupMembersData>) => {
    return infiniteQueryOptions<ListUserGroupMembersResponse, DefaultError, InfiniteData<ListUserGroupMembersResponse>, QueryKey<Options<ListUserGroupMembersData>>, string | Pick<QueryKey<Options<ListUserGroupMembersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListUserGroupMembersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listUserGroupMembers({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listUserGroupMembersInfiniteQueryKey(options)
    });
};

export const assignUserToGroupQueryKey = (options: Options<AssignUserToGroupData>) => createQueryKey('assignUserToGroup', options);

/**
 * Assign a user to the group
 */
export const assignUserToGroupOptions = (options: Options<AssignUserToGroupData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await assignUserToGroup({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: assignUserToGroupQueryKey(options)
    });
};

/**
 * Assign a user to the group
 */
export const assignUserToGroupMutation = (options?: Partial<Options<AssignUserToGroupData>>): UseMutationOptions<unknown, DefaultError, Options<AssignUserToGroupData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<AssignUserToGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assignUserToGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const countUserGroupMembersQueryKey = (options: Options<CountUserGroupMembersData>) => createQueryKey('countUserGroupMembers', options);

/**
 * Count the users in a group
 *
 * Returns the number of group members matching the given filters. Accepts the same filters as `listUserGroupMembers` so that the count reflects the currently displayed result set.
 */
export const countUserGroupMembersOptions = (options: Options<CountUserGroupMembersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await countUserGroupMembers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: countUserGroupMembersQueryKey(options)
    });
};

/**
 * Reactivate a user in the group
 */
export const reactivateUserInGroupMutation = (options?: Partial<Options<ReactivateUserInGroupData>>): UseMutationOptions<unknown, DefaultError, Options<ReactivateUserInGroupData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<ReactivateUserInGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await reactivateUserInGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUserGroupMemberQueryKey = (options: Options<GetUserGroupMemberData>) => createQueryKey('getUserGroupMember', options);

/**
 * Get user group membership
 */
export const getUserGroupMemberOptions = (options: Options<GetUserGroupMemberData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getUserGroupMember({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getUserGroupMemberQueryKey(options)
    });
};

/**
 * Update user group membership
 */
export const updateUserGroupMemberMutation = (options?: Partial<Options<UpdateUserGroupMemberData>>): UseMutationOptions<UpdateUserGroupMemberResponse2, DefaultError, Options<UpdateUserGroupMemberData>> => {
    const mutationOptions: UseMutationOptions<UpdateUserGroupMemberResponse2, DefaultError, Options<UpdateUserGroupMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateUserGroupMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUserGroupMemberLevelHistoryQueryKey = (options: Options<GetUserGroupMemberLevelHistoryData>) => createQueryKey('getUserGroupMemberLevelHistory', options);

/**
 * Get user group membership level history
 */
export const getUserGroupMemberLevelHistoryOptions = (options: Options<GetUserGroupMemberLevelHistoryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getUserGroupMemberLevelHistory({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getUserGroupMemberLevelHistoryQueryKey(options)
    });
};

export const getUserGroupMemberLevelHistoryInfiniteQueryKey = (options: Options<GetUserGroupMemberLevelHistoryData>): QueryKey<Options<GetUserGroupMemberLevelHistoryData>> => createQueryKey('getUserGroupMemberLevelHistory', options, true);

/**
 * Get user group membership level history
 */
export const getUserGroupMemberLevelHistoryInfiniteOptions = (options: Options<GetUserGroupMemberLevelHistoryData>) => {
    return infiniteQueryOptions<GetUserGroupMemberLevelHistoryResponse, DefaultError, InfiniteData<GetUserGroupMemberLevelHistoryResponse>, QueryKey<Options<GetUserGroupMemberLevelHistoryData>>, string | Pick<QueryKey<Options<GetUserGroupMemberLevelHistoryData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetUserGroupMemberLevelHistoryData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getUserGroupMemberLevelHistory({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getUserGroupMemberLevelHistoryInfiniteQueryKey(options)
    });
};

export const adjustUserGroupMemberSkillQueryKey = (options: Options<AdjustUserGroupMemberSkillData>) => createQueryKey('adjustUserGroupMemberSkill', options);

/**
 * Adjust user skills in the group
 */
export const adjustUserGroupMemberSkillOptions = (options: Options<AdjustUserGroupMemberSkillData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adjustUserGroupMemberSkill({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adjustUserGroupMemberSkillQueryKey(options)
    });
};

/**
 * Adjust user skills in the group
 */
export const adjustUserGroupMemberSkillMutation = (options?: Partial<Options<AdjustUserGroupMemberSkillData>>): UseMutationOptions<AdjustUserGroupMemberSkillResponse, DefaultError, Options<AdjustUserGroupMemberSkillData>> => {
    const mutationOptions: UseMutationOptions<AdjustUserGroupMemberSkillResponse, DefaultError, Options<AdjustUserGroupMemberSkillData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adjustUserGroupMemberSkill({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listWebhooksQueryKey = (options: Options<ListWebhooksData>) => createQueryKey('listWebhooks', options);

/**
 * List webhooks for a given project
 */
export const listWebhooksOptions = (options: Options<ListWebhooksData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listWebhooks({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listWebhooksQueryKey(options)
    });
};

export const createWebhookQueryKey = (options: Options<CreateWebhookData>) => createQueryKey('createWebhook', options);

/**
 * Create a new webhook for a given project
 */
export const createWebhookOptions = (options: Options<CreateWebhookData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createWebhook({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createWebhookQueryKey(options)
    });
};

/**
 * Create a new webhook for a given project
 */
export const createWebhookMutation = (options?: Partial<Options<CreateWebhookData>>): UseMutationOptions<CreateWebhookResponse, DefaultError, Options<CreateWebhookData>> => {
    const mutationOptions: UseMutationOptions<CreateWebhookResponse, DefaultError, Options<CreateWebhookData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createWebhook({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a webhook for a given project
 */
export const deleteWebhookMutation = (options?: Partial<Options<DeleteWebhookData>>): UseMutationOptions<DeleteWebhookResponse, DefaultError, Options<DeleteWebhookData>> => {
    const mutationOptions: UseMutationOptions<DeleteWebhookResponse, DefaultError, Options<DeleteWebhookData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteWebhook({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update a webhook for a given project
 */
export const updateWebhookMutation = (options?: Partial<Options<UpdateWebhookData>>): UseMutationOptions<UpdateWebhookResponse, DefaultError, Options<UpdateWebhookData>> => {
    const mutationOptions: UseMutationOptions<UpdateWebhookResponse, DefaultError, Options<UpdateWebhookData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateWebhook({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getWorkItemMetadataFormQueryKey = (options: Options<GetWorkItemMetadataFormData>) => createQueryKey('getWorkItemMetadataForm', options);

/**
 * Get work item metadata form for a project
 */
export const getWorkItemMetadataFormOptions = (options: Options<GetWorkItemMetadataFormData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getWorkItemMetadataForm({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getWorkItemMetadataFormQueryKey(options)
    });
};

export const createWorkItemMetadataFormQueryKey = (options: Options<CreateWorkItemMetadataFormData>) => createQueryKey('createWorkItemMetadataForm', options);

/**
 * Create a new work item metadata form for a project
 */
export const createWorkItemMetadataFormOptions = (options: Options<CreateWorkItemMetadataFormData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createWorkItemMetadataForm({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createWorkItemMetadataFormQueryKey(options)
    });
};

/**
 * Create a new work item metadata form for a project
 */
export const createWorkItemMetadataFormMutation = (options?: Partial<Options<CreateWorkItemMetadataFormData>>): UseMutationOptions<CreateWorkItemMetadataFormResponse, DefaultError, Options<CreateWorkItemMetadataFormData>> => {
    const mutationOptions: UseMutationOptions<CreateWorkItemMetadataFormResponse, DefaultError, Options<CreateWorkItemMetadataFormData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createWorkItemMetadataForm({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listWorkItemsQueryKey = (options: Options<ListWorkItemsData>) => createQueryKey('listWorkItems', options);

/**
 * List all work items under a project
 */
export const listWorkItemsOptions = (options: Options<ListWorkItemsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listWorkItems({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listWorkItemsQueryKey(options)
    });
};

export const listWorkItemsInfiniteQueryKey = (options: Options<ListWorkItemsData>): QueryKey<Options<ListWorkItemsData>> => createQueryKey('listWorkItems', options, true);

/**
 * List all work items under a project
 */
export const listWorkItemsInfiniteOptions = (options: Options<ListWorkItemsData>) => {
    return infiniteQueryOptions<ListWorkItemsResponse, DefaultError, InfiniteData<ListWorkItemsResponse>, QueryKey<Options<ListWorkItemsData>>, string | Pick<QueryKey<Options<ListWorkItemsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListWorkItemsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listWorkItems({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listWorkItemsInfiniteQueryKey(options)
    });
};

export const listWorkItemsStatsQueryKey = (options: Options<ListWorkItemsStatsData>) => createQueryKey('listWorkItemsStats', options);

/**
 * Get work item stats under a project
 */
export const listWorkItemsStatsOptions = (options: Options<ListWorkItemsStatsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listWorkItemsStats({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listWorkItemsStatsQueryKey(options)
    });
};

export const countWorkItemsQueryKey = (options: Options<CountWorkItemsData>) => createQueryKey('countWorkItems', options);

/**
 * Count work items under a project with optional filters
 */
export const countWorkItemsOptions = (options: Options<CountWorkItemsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await countWorkItems({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: countWorkItemsQueryKey(options)
    });
};

export const getWorkItemInferenceQueryKey = (options: Options<GetWorkItemInferenceData>) => createQueryKey('getWorkItemInference', options);

/**
 * Get inference by ID
 */
export const getWorkItemInferenceOptions = (options: Options<GetWorkItemInferenceData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getWorkItemInference({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getWorkItemInferenceQueryKey(options)
    });
};

export const getWorkItemsByQueryQueryKey = (options?: Options<GetWorkItemsByQueryData>) => createQueryKey('getWorkItemsByQuery', options);

/**
 * Get work item by query params
 */
export const getWorkItemsByQueryOptions = (options?: Options<GetWorkItemsByQueryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getWorkItemsByQuery({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getWorkItemsByQueryQueryKey(options)
    });
};

export const getWorkItemsByQueryInfiniteQueryKey = (options?: Options<GetWorkItemsByQueryData>): QueryKey<Options<GetWorkItemsByQueryData>> => createQueryKey('getWorkItemsByQuery', options, true);

/**
 * Get work item by query params
 */
export const getWorkItemsByQueryInfiniteOptions = (options?: Options<GetWorkItemsByQueryData>) => {
    return infiniteQueryOptions<GetWorkItemsByQueryResponse, DefaultError, InfiniteData<GetWorkItemsByQueryResponse>, QueryKey<Options<GetWorkItemsByQueryData>>, string | Pick<QueryKey<Options<GetWorkItemsByQueryData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetWorkItemsByQueryData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getWorkItemsByQuery({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getWorkItemsByQueryInfiniteQueryKey(options)
    });
};

export const listAnnotationsByQueryQueryKey = (options: Options<ListAnnotationsByQueryData>) => createQueryKey('listAnnotationsByQuery', options);

/**
 * Get annotations by query params
 */
export const listAnnotationsByQueryOptions = (options: Options<ListAnnotationsByQueryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listAnnotationsByQuery({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listAnnotationsByQueryQueryKey(options)
    });
};

export const listAnnotationsByQueryInfiniteQueryKey = (options: Options<ListAnnotationsByQueryData>): QueryKey<Options<ListAnnotationsByQueryData>> => createQueryKey('listAnnotationsByQuery', options, true);

/**
 * Get annotations by query params
 */
export const listAnnotationsByQueryInfiniteOptions = (options: Options<ListAnnotationsByQueryData>) => {
    return infiniteQueryOptions<ListAnnotationsByQueryResponse, DefaultError, InfiniteData<ListAnnotationsByQueryResponse>, QueryKey<Options<ListAnnotationsByQueryData>>, string | Pick<QueryKey<Options<ListAnnotationsByQueryData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListAnnotationsByQueryData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listAnnotationsByQuery({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listAnnotationsByQueryInfiniteQueryKey(options)
    });
};

export const getFormDetailsFromAnnotationQueryKey = (options: Options<GetFormDetailsFromAnnotationData>) => createQueryKey('getFormDetailsFromAnnotation', options);

/**
 * Get annotation form details by annotation ID
 */
export const getFormDetailsFromAnnotationOptions = (options: Options<GetFormDetailsFromAnnotationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFormDetailsFromAnnotation({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getFormDetailsFromAnnotationQueryKey(options)
    });
};

/**
 * Update annotation inference details by annotation id
 */
export const updateAnnotationMutation = (options?: Partial<Options<UpdateAnnotationData>>): UseMutationOptions<UpdateAnnotationResponse, DefaultError, Options<UpdateAnnotationData>> => {
    const mutationOptions: UseMutationOptions<UpdateAnnotationResponse, DefaultError, Options<UpdateAnnotationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateAnnotation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Soft-delete a work item
 */
export const internalDeleteWorkItemMutation = (options?: Partial<Options<InternalDeleteWorkItemData>>): UseMutationOptions<InternalDeleteWorkItemResponse, DefaultError, Options<InternalDeleteWorkItemData>> => {
    const mutationOptions: UseMutationOptions<InternalDeleteWorkItemResponse, DefaultError, Options<InternalDeleteWorkItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await internalDeleteWorkItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getWorkItemQueryKey = (options: Options<GetWorkItemData>) => createQueryKey('getWorkItem', options);

/**
 * Get a single work item by ID
 */
export const getWorkItemOptions = (options: Options<GetWorkItemData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getWorkItem({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getWorkItemQueryKey(options)
    });
};

export const internalCancelWorkItemQueryKey = (options: Options<InternalCancelWorkItemData>) => createQueryKey('internalCancelWorkItem', options);

/**
 * Cancel a work item
 */
export const internalCancelWorkItemOptions = (options: Options<InternalCancelWorkItemData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await internalCancelWorkItem({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: internalCancelWorkItemQueryKey(options)
    });
};

/**
 * Cancel a work item
 */
export const internalCancelWorkItemMutation = (options?: Partial<Options<InternalCancelWorkItemData>>): UseMutationOptions<InternalCancelWorkItemResponse, DefaultError, Options<InternalCancelWorkItemData>> => {
    const mutationOptions: UseMutationOptions<InternalCancelWorkItemResponse, DefaultError, Options<InternalCancelWorkItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await internalCancelWorkItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const internalReopenWorkItemQueryKey = (options: Options<InternalReopenWorkItemData>) => createQueryKey('internalReopenWorkItem', options);

/**
 * Reopen work item
 *
 * Creates a new iteration of work item. Supports terminal statuses (COMPLETED, FAILED, CANCELED) and active statuses (IN_PROGRESS, CLIENT_REVIEW) which will be canceled atomically before creating the new iteration.
 */
export const internalReopenWorkItemOptions = (options: Options<InternalReopenWorkItemData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await internalReopenWorkItem({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: internalReopenWorkItemQueryKey(options)
    });
};

/**
 * Reopen work item
 *
 * Creates a new iteration of work item. Supports terminal statuses (COMPLETED, FAILED, CANCELED) and active statuses (IN_PROGRESS, CLIENT_REVIEW) which will be canceled atomically before creating the new iteration.
 */
export const internalReopenWorkItemMutation = (options?: Partial<Options<InternalReopenWorkItemData>>): UseMutationOptions<InternalReopenWorkItemResponse, DefaultError, Options<InternalReopenWorkItemData>> => {
    const mutationOptions: UseMutationOptions<InternalReopenWorkItemResponse, DefaultError, Options<InternalReopenWorkItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await internalReopenWorkItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const bulkCancelWorkItemsQueryKey = (options: Options<BulkCancelWorkItemsData>) => createQueryKey('bulkCancelWorkItems', options);

/**
 * Bulk cancel work items
 *
 * Cancels a bulk selection of work items — either an explicit list of IDs or everything matching a filter. Resolves and validates the scope synchronously and returns 202 with a job ID immediately; per-item processing happens asynchronously afterward and applies the exact same rules as single-item cancel.
 */
export const bulkCancelWorkItemsOptions = (options: Options<BulkCancelWorkItemsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await bulkCancelWorkItems({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: bulkCancelWorkItemsQueryKey(options)
    });
};

/**
 * Bulk cancel work items
 *
 * Cancels a bulk selection of work items — either an explicit list of IDs or everything matching a filter. Resolves and validates the scope synchronously and returns 202 with a job ID immediately; per-item processing happens asynchronously afterward and applies the exact same rules as single-item cancel.
 */
export const bulkCancelWorkItemsMutation = (options?: Partial<Options<BulkCancelWorkItemsData>>): UseMutationOptions<BulkCancelWorkItemsResponse, DefaultError, Options<BulkCancelWorkItemsData>> => {
    const mutationOptions: UseMutationOptions<BulkCancelWorkItemsResponse, DefaultError, Options<BulkCancelWorkItemsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bulkCancelWorkItems({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const bulkReopenWorkItemsQueryKey = (options: Options<BulkReopenWorkItemsData>) => createQueryKey('bulkReopenWorkItems', options);

/**
 * Bulk reopen work items
 *
 * Reopens a bulk selection of work items — either an explicit list of IDs or everything matching a filter. Resolves and validates the scope synchronously and returns 202 with a job ID immediately; per-item processing happens asynchronously afterward and applies the exact same rules as single-item reopen.
 */
export const bulkReopenWorkItemsOptions = (options: Options<BulkReopenWorkItemsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await bulkReopenWorkItems({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: bulkReopenWorkItemsQueryKey(options)
    });
};

/**
 * Bulk reopen work items
 *
 * Reopens a bulk selection of work items — either an explicit list of IDs or everything matching a filter. Resolves and validates the scope synchronously and returns 202 with a job ID immediately; per-item processing happens asynchronously afterward and applies the exact same rules as single-item reopen.
 */
export const bulkReopenWorkItemsMutation = (options?: Partial<Options<BulkReopenWorkItemsData>>): UseMutationOptions<BulkReopenWorkItemsResponse, DefaultError, Options<BulkReopenWorkItemsData>> => {
    const mutationOptions: UseMutationOptions<BulkReopenWorkItemsResponse, DefaultError, Options<BulkReopenWorkItemsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bulkReopenWorkItems({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getWorkItemAnnotationQueryKey = (options: Options<GetWorkItemAnnotationData>) => createQueryKey('getWorkItemAnnotation', options);

/**
 * Get annotation for a work item
 *
 * Returns the annotation (including resultsUrl) for a specific work item.
 */
export const getWorkItemAnnotationOptions = (options: Options<GetWorkItemAnnotationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getWorkItemAnnotation({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getWorkItemAnnotationQueryKey(options)
    });
};

export const getWorkItemExecutionQueryKey = (options: Options<GetWorkItemExecutionData>) => createQueryKey('getWorkItemExecution', options);

/**
 * Get work item execution
 *
 * Returns the work item execution results
 */
export const getWorkItemExecutionOptions = (options: Options<GetWorkItemExecutionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getWorkItemExecution({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getWorkItemExecutionQueryKey(options)
    });
};

export const createOutputNameLinkQueryKey = (options: Options<CreateOutputNameLinkData>) => createQueryKey('createOutputNameLink', options);

/**
 * Create output name link for a work item
 */
export const createOutputNameLinkOptions = (options: Options<CreateOutputNameLinkData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createOutputNameLink({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createOutputNameLinkQueryKey(options)
    });
};

/**
 * Create output name link for a work item
 */
export const createOutputNameLinkMutation = (options?: Partial<Options<CreateOutputNameLinkData>>): UseMutationOptions<CreateOutputNameLinkResponse, DefaultError, Options<CreateOutputNameLinkData>> => {
    const mutationOptions: UseMutationOptions<CreateOutputNameLinkResponse, DefaultError, Options<CreateOutputNameLinkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createOutputNameLink({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listEvalExpressionsQueryKey = (options: Options<ListEvalExpressionsData>) => createQueryKey('listEvalExpressions', options);

/**
 * List all non-deleted eval expression rules for a space (active and inactive)
 */
export const listEvalExpressionsOptions = (options: Options<ListEvalExpressionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listEvalExpressions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listEvalExpressionsQueryKey(options)
    });
};

export const createEvalExpressionQueryKey = (options: Options<CreateEvalExpressionData>) => createQueryKey('createEvalExpression', options);

/**
 * Create a new QA heuristic eval expression rule for a space
 */
export const createEvalExpressionOptions = (options: Options<CreateEvalExpressionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createEvalExpression({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createEvalExpressionQueryKey(options)
    });
};

/**
 * Create a new QA heuristic eval expression rule for a space
 */
export const createEvalExpressionMutation = (options?: Partial<Options<CreateEvalExpressionData>>): UseMutationOptions<CreateEvalExpressionResponse, CreateEvalExpressionError, Options<CreateEvalExpressionData>> => {
    const mutationOptions: UseMutationOptions<CreateEvalExpressionResponse, CreateEvalExpressionError, Options<CreateEvalExpressionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createEvalExpression({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getEvalExpressionQueryKey = (options: Options<GetEvalExpressionData>) => createQueryKey('getEvalExpression', options);

/**
 * Get a single eval expression rule by ID
 */
export const getEvalExpressionOptions = (options: Options<GetEvalExpressionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getEvalExpression({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getEvalExpressionQueryKey(options)
    });
};

/**
 * Update an existing eval expression rule
 */
export const updateEvalExpressionMutation = (options?: Partial<Options<UpdateEvalExpressionData>>): UseMutationOptions<UpdateEvalExpressionResponse, UpdateEvalExpressionError, Options<UpdateEvalExpressionData>> => {
    const mutationOptions: UseMutationOptions<UpdateEvalExpressionResponse, UpdateEvalExpressionError, Options<UpdateEvalExpressionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateEvalExpression({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const testEvalExpressionQueryKey = (options: Options<TestEvalExpressionData>) => createQueryKey('testEvalExpression', options);

/**
 * Test/simulate an eval expression rule against sample inference data
 *
 * Evaluates an ad-hoc expression (with optional taxonomyField/severity/message) against a
 * caller-supplied sample inference payload and returns whether it would pass, plus the
 * MLError(s) that would be produced if it failed. Nothing is persisted - no eval_expression
 * or eval_error rows are created.
 *
 */
export const testEvalExpressionOptions = (options: Options<TestEvalExpressionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await testEvalExpression({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: testEvalExpressionQueryKey(options)
    });
};

/**
 * Test/simulate an eval expression rule against sample inference data
 *
 * Evaluates an ad-hoc expression (with optional taxonomyField/severity/message) against a
 * caller-supplied sample inference payload and returns whether it would pass, plus the
 * MLError(s) that would be produced if it failed. Nothing is persisted - no eval_expression
 * or eval_error rows are created.
 *
 */
export const testEvalExpressionMutation = (options?: Partial<Options<TestEvalExpressionData>>): UseMutationOptions<TestEvalExpressionResponse2, TestEvalExpressionError, Options<TestEvalExpressionData>> => {
    const mutationOptions: UseMutationOptions<TestEvalExpressionResponse2, TestEvalExpressionError, Options<TestEvalExpressionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await testEvalExpression({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listBlockCatalogQueryKey = (options?: Options<ListBlockCatalogData>) => createQueryKey('listBlockCatalog', options);

/**
 * List all available block types and categories (catalog)
 */
export const listBlockCatalogOptions = (options?: Options<ListBlockCatalogData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listBlockCatalog({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listBlockCatalogQueryKey(options)
    });
};

export const getWorkflowQueryKey = (options: Options<GetWorkflowData>) => createQueryKey('getWorkflow', options);

/**
 * Get the active workflow for a given project
 */
export const getWorkflowOptions = (options: Options<GetWorkflowData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getWorkflow({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getWorkflowQueryKey(options)
    });
};

/**
 * Update a workflow
 */
export const updateWorkflowMutation = (options?: Partial<Options<UpdateWorkflowData>>): UseMutationOptions<UpdateWorkflowResponse, DefaultError, Options<UpdateWorkflowData>> => {
    const mutationOptions: UseMutationOptions<UpdateWorkflowResponse, DefaultError, Options<UpdateWorkflowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateWorkflow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update workflow definition (compile and register with orchestrator)
 *
 * Accepts a WorkflowIR, compiles it to orchestrator format, saves both representations
 * to blob storage, and registers with the orchestrator. Does not update workflow metadata
 * (name, description) in the database - use PUT /workflows/{workflowID} for that.
 *
 */
export const updateWorkflowDefinitionMutation = (options?: Partial<Options<UpdateWorkflowDefinitionData>>): UseMutationOptions<UpdateWorkflowDefinitionResponse2, UpdateWorkflowDefinitionError, Options<UpdateWorkflowDefinitionData>> => {
    const mutationOptions: UseMutationOptions<UpdateWorkflowDefinitionResponse2, UpdateWorkflowDefinitionError, Options<UpdateWorkflowDefinitionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateWorkflowDefinition({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listWorkflowVersionsQueryKey = (options: Options<ListWorkflowVersionsData>) => createQueryKey('listWorkflowVersions', options);

/**
 * List all published versions of a workflow
 *
 * Returns all published versions of the workflow in descending order (newest first).
 * Returns an empty array if the workflow has no published versions.
 *
 */
export const listWorkflowVersionsOptions = (options: Options<ListWorkflowVersionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listWorkflowVersions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listWorkflowVersionsQueryKey(options)
    });
};

export const publishWorkflowQueryKey = (options: Options<PublishWorkflowData>) => createQueryKey('publishWorkflow', options);

/**
 * Publish current workflow draft as a new immutable version
 *
 * Creates a new published version from the current draft definition. This:
 * 1. Loads the current workflow conductor definition
 * 2. Registers the workflow with Conductor orchestrator
 * 3. Creates an immutable version record in the database
 * 4. Increments the workflow's version counter
 * 5. Resets has_unpublished_changes to false
 *
 */
export const publishWorkflowOptions = (options: Options<PublishWorkflowData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await publishWorkflow({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: publishWorkflowQueryKey(options)
    });
};

/**
 * Publish current workflow draft as a new immutable version
 *
 * Creates a new published version from the current draft definition. This:
 * 1. Loads the current workflow conductor definition
 * 2. Registers the workflow with Conductor orchestrator
 * 3. Creates an immutable version record in the database
 * 4. Increments the workflow's version counter
 * 5. Resets has_unpublished_changes to false
 *
 */
export const publishWorkflowMutation = (options?: Partial<Options<PublishWorkflowData>>): UseMutationOptions<PublishWorkflowResponse, PublishWorkflowError, Options<PublishWorkflowData>> => {
    const mutationOptions: UseMutationOptions<PublishWorkflowResponse, PublishWorkflowError, Options<PublishWorkflowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await publishWorkflow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getWorkflowDefinitionByVersionQueryKey = (options: Options<GetWorkflowDefinitionByVersionData>) => createQueryKey('getWorkflowDefinitionByVersion', options);

/**
 * Get workflow definition for a specific version
 *
 * Retrieves the workflow IR (intermediate representation) for a specific version.
 * - For published versions (< latest_version): Returns the published IR
 * - For draft version (= latest_version with has_unpublished_changes=true): Returns the draft IR
 * - Returns 404 if version doesn't exist or is invalid
 *
 */
export const getWorkflowDefinitionByVersionOptions = (options: Options<GetWorkflowDefinitionByVersionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getWorkflowDefinitionByVersion({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getWorkflowDefinitionByVersionQueryKey(options)
    });
};

export const listWorkflowsQueryKey = (options: Options<ListWorkflowsData>) => createQueryKey('listWorkflows', options);

/**
 * List workflows for a given space
 */
export const listWorkflowsOptions = (options: Options<ListWorkflowsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listWorkflows({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listWorkflowsQueryKey(options)
    });
};

export const createWorkflowQueryKey = (options: Options<CreateWorkflowData>) => createQueryKey('createWorkflow', options);

/**
 * Create a workflow for a given space
 */
export const createWorkflowOptions = (options: Options<CreateWorkflowData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createWorkflow({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createWorkflowQueryKey(options)
    });
};

/**
 * Create a workflow for a given space
 */
export const createWorkflowMutation = (options?: Partial<Options<CreateWorkflowData>>): UseMutationOptions<CreateWorkflowResponse, DefaultError, Options<CreateWorkflowData>> => {
    const mutationOptions: UseMutationOptions<CreateWorkflowResponse, DefaultError, Options<CreateWorkflowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createWorkflow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listWorkflowTemplatesQueryKey = (options?: Options<ListWorkflowTemplatesData>) => createQueryKey('listWorkflowTemplates', options);

/**
 * List available workflow templates
 */
export const listWorkflowTemplatesOptions = (options?: Options<ListWorkflowTemplatesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listWorkflowTemplates({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listWorkflowTemplatesQueryKey(options)
    });
};

export const listWorkflowTemplatesInfiniteQueryKey = (options?: Options<ListWorkflowTemplatesData>): QueryKey<Options<ListWorkflowTemplatesData>> => createQueryKey('listWorkflowTemplates', options, true);

/**
 * List available workflow templates
 */
export const listWorkflowTemplatesInfiniteOptions = (options?: Options<ListWorkflowTemplatesData>) => {
    return infiniteQueryOptions<ListWorkflowTemplatesResponse, DefaultError, InfiniteData<ListWorkflowTemplatesResponse>, QueryKey<Options<ListWorkflowTemplatesData>>, string | Pick<QueryKey<Options<ListWorkflowTemplatesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListWorkflowTemplatesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listWorkflowTemplates({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listWorkflowTemplatesInfiniteQueryKey(options)
    });
};

export const getWorkflowTemplateQueryKey = (options: Options<GetWorkflowTemplateData>) => createQueryKey('getWorkflowTemplate', options);

/**
 * Get a workflow template by ID
 */
export const getWorkflowTemplateOptions = (options: Options<GetWorkflowTemplateData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getWorkflowTemplate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getWorkflowTemplateQueryKey(options)
    });
};

export const listAllWorkflowVersionsQueryKey = (options: Options<ListAllWorkflowVersionsData>) => createQueryKey('listAllWorkflowVersions', options);

/**
 * List workflow published workflows and their versions
 */
export const listAllWorkflowVersionsOptions = (options: Options<ListAllWorkflowVersionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listAllWorkflowVersions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listAllWorkflowVersionsQueryKey(options)
    });
};
